export const FORMS: any[] = [
  //Content
    {
      "name" : "FindContent",
      "altTarget" : [ ],
      "formLocation" : "component://content/widget/content/ContentForms.xml",
      "target" : "findContent",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "noConditionFind",
        "action" : "",
        "id" : "FindContent_noConditionFind",
        "type" : "hidden",
        "event" : "",
        "value" : "Y"
      }, {
        "fieldHelpText" : "",
        "maxlength" : "",
        "autocomplete" : "",
        "tabindex" : "",
        "conditionGroup" : "",
        "defaultOption" : "contains",
        "opEquals" : "Equals",
        "opNotEqual" : "Not Equal",
        "className" : "",
        "title" : "Content ID",
        "type" : "textqbe",
        "opBeginsWith" : "Begins With",
        "opContains" : "Contains",
        "opIsEmpty" : "Is Empty",
        "size" : "25",
        "alert" : "false",
        "ignoreCase" : "Ignore Case",
        "name" : "contentId",
        "hideIgnoreCase" : "false",
        "style" : "",
        "titleStyle" : "",
        "id" : "FindContent_contentId",
        "value" : "",
        "ignCase" : "true"
      }, {
        "fieldHelpText" : "",
        "maxlength" : "",
        "autocomplete" : "",
        "tabindex" : "",
        "conditionGroup" : "",
        "defaultOption" : "contains",
        "opEquals" : "Equals",
        "opNotEqual" : "Not Equal",
        "className" : "",
        "title" : "Content Name",
        "type" : "textqbe",
        "opBeginsWith" : "Begins With",
        "opContains" : "Contains",
        "opIsEmpty" : "Is Empty",
        "size" : "25",
        "alert" : "false",
        "ignoreCase" : "Ignore Case",
        "name" : "contentName",
        "hideIgnoreCase" : "false",
        "style" : "",
        "titleStyle" : "",
        "id" : "FindContent_contentName",
        "value" : "",
        "ignCase" : "true"
      }, {
        "fieldHelpText" : "",
        "maxlength" : "",
        "autocomplete" : "",
        "tabindex" : "",
        "conditionGroup" : "",
        "defaultOption" : "contains",
        "opEquals" : "Equals",
        "opNotEqual" : "Not Equal",
        "className" : "",
        "title" : "Description",
        "type" : "textqbe",
        "opBeginsWith" : "Begins With",
        "opContains" : "Contains",
        "opIsEmpty" : "Is Empty",
        "size" : "25",
        "alert" : "false",
        "ignoreCase" : "Ignore Case",
        "name" : "description",
        "hideIgnoreCase" : "false",
        "style" : "",
        "titleStyle" : "",
        "id" : "FindContent_description",
        "value" : "",
        "ignCase" : "true"
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Content Type ID",
        "type" : "dropdown",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "Y",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "FindContent",
        "allOptionValues" : [ {
          "description" : "Annotation",
          "key" : "ANNOTATION"
        }, {
          "description" : "Birt report (.rptDesign) file",
          "key" : "RPTDESIGN"
        }, {
          "description" : "Blog Root",
          "key" : "BLOG_ROOT"
        }, {
          "description" : "Content List",
          "key" : "CONTENT_LIST"
        }, {
          "description" : "Decorator",
          "key" : "DECORATOR"
        }, {
          "description" : "Department",
          "key" : "DEPARTMENT"
        }, {
          "description" : "Document",
          "key" : "DOCUMENT"
        }, {
          "description" : "FAQ Root",
          "key" : "FAQ_ROOT"
        }, {
          "description" : "Forum root publish point",
          "key" : "FORUM_ROOT"
        }, {
          "description" : "Frame Image",
          "key" : "IMAGE_FRAME"
        }, {
          "description" : "Graph Root",
          "key" : "GRAPH_ROOT"
        }, {
          "description" : "Menu Container",
          "key" : "MENU_CONTAINER"
        }, {
          "description" : "Outline Node",
          "key" : "OUTLINE_NODE"
        }, {
          "description" : "Page Node",
          "key" : "PAGE_NODE"
        }, {
          "description" : "People",
          "key" : "PEOPLE"
        }, {
          "description" : "Person",
          "key" : "PERSON"
        }, {
          "description" : "Place Holder",
          "key" : "PLACEHOLDER"
        }, {
          "description" : "Publish Point",
          "key" : "WEB_SITE_PUB_PT"
        }, {
          "description" : "Report",
          "key" : "FLEXIBLE_REPORT"
        }, {
          "description" : "Report Master",
          "key" : "REPORT_MASTER"
        }, {
          "description" : "Structure Definition (like DTD)",
          "key" : "STRUCTURE_DEF"
        }, {
          "description" : "Structure Leaf",
          "key" : "STRUCTURE_LEAF"
        }, {
          "description" : "Structure Node",
          "key" : "STRUCTURE_NODE"
        }, {
          "description" : "Sub Page Node",
          "key" : "SUBPAGE_NODE"
        }, {
          "description" : "Template or Form",
          "key" : "TEMPLATE"
        }, {
          "description" : "Topic",
          "key" : "TOPIC"
        }, {
          "description" : "Transformation Definition (like XSLT)",
          "key" : "TXFORM_DEF"
        }, {
          "description" : "Tree Root",
          "key" : "TREE_ROOT"
        } ],
        "disabled" : "false",
        "id" : "FindContent_contentTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "contentTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Mime Type ID",
        "type" : "dropdown",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "Y",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "FindContent",
        "allOptionValues" : [ {
          "description" : "3GP Mobile Video",
          "key" : "video/3gpp"
        }, {
          "description" : "ASF Video",
          "key" : "video/x-ms-asf"
        }, {
          "description" : "AVI Video",
          "key" : "video/avi"
        }, {
          "description" : "Adobe Portable Document Format (PDF)",
          "key" : "application/pdf"
        }, {
          "description" : "Arbitrary Binary Data",
          "key" : "application/octet-stream"
        }, {
          "description" : "Basic Audio",
          "key" : "audio/basic"
        }, {
          "description" : "CSS Text",
          "key" : "text/css"
        }, {
          "description" : "Comma Separated Value Text ",
          "key" : "text/csv"
        }, {
          "description" : "Digest of Messages Multipart",
          "key" : "multipart/digest"
        }, {
          "description" : "Encrypted Multipart",
          "key" : "multipart/encrypted"
        }, {
          "description" : "Enriched Text",
          "key" : "text/enriched"
        }, {
          "description" : "External Body Message",
          "key" : "message/external-body"
        }, {
          "description" : "FLAC Audio",
          "key" : "audio/x-flac"
        }, {
          "description" : "FLAC Audio",
          "key" : "audio/flac"
        }, {
          "description" : "Flash Streaming Video",
          "key" : "video/x-flv"
        }, {
          "description" : "Form Data Multipart",
          "key" : "multipart/form-data"
        }, {
          "description" : "GIF Image",
          "key" : "image/gif"
        }, {
          "description" : "Gzipped Tar archive file",
          "key" : "application/x-tgz"
        }, {
          "description" : "HTML Text",
          "key" : "text/html"
        }, {
          "description" : "HTTP Message",
          "key" : "message/http"
        }, {
          "description" : "HTTPS/S-HTTP Message",
          "key" : "message/s-http"
        }, {
          "description" : "Image SVG",
          "key" : "image/svg+xml"
        }, {
          "description" : "JPEG/JPG Image",
          "key" : "image/jpeg"
        }, {
          "description" : "MP4 Audio",
          "key" : "audio/mp4"
        }, {
          "description" : "MPEG Audio",
          "key" : "audio/mpeg"
        }, {
          "description" : "MPEG-4 (H.264) Video",
          "key" : "video/mp4"
        }, {
          "description" : "MPEG/MPG Video",
          "key" : "video/mpeg"
        }, {
          "description" : "Mesh Model",
          "key" : "model/mesh"
        }, {
          "description" : "Microsoft Excel",
          "key" : "application/vnd.ms-excel"
        }, {
          "description" : "Microsoft PowerPoint",
          "key" : "application/vnd.ms-powerpoint"
        }, {
          "description" : "Microsoft Word",
          "key" : "application/msword"
        }, {
          "description" : "Mixed Type Multipart",
          "key" : "multipart/mixed"
        }, {
          "description" : "Mutliple Alternative Multipart",
          "key" : "multipart/alternative"
        }, {
          "description" : "News Message",
          "key" : "message/news"
        }, {
          "description" : "OGG Audio",
          "key" : "audio/ogg"
        }, {
          "description" : "OGG Audio",
          "key" : "audio/x-ogg"
        }, {
          "description" : "OpenOffice OpenDocument Spreadsheet",
          "key" : "application/vnd.oasis.opendocument.spreadsheet"
        }, {
          "description" : "OpenOffice OpenDocument Text",
          "key" : "application/vnd.oasis.opendocument.text"
        }, {
          "description" : "PKCS7 Signature",
          "key" : "application/pkcs7-signature"
        }, {
          "description" : "PNG Image",
          "key" : "image/png"
        }, {
          "description" : "Partial Message",
          "key" : "message/partial"
        }, {
          "description" : "Plain Text",
          "key" : "text/plain"
        }, {
          "description" : "Post script Application/Script",
          "key" : "application/postscript"
        }, {
          "description" : "Progressive JPEG/JPG Image",
          "key" : "image/pjpeg"
        }, {
          "description" : "Quicktime Video",
          "key" : "video/quicktime"
        }, {
          "description" : "RFC 822 Headered Message",
          "key" : "message/rfc822"
        }, {
          "description" : "RTF Rich Text",
          "key" : "text/rtf"
        }, {
          "description" : "Related Multipart",
          "key" : "multipart/related"
        }, {
          "description" : "Rich Text",
          "key" : "text/richtext"
        }, {
          "description" : "SGML Text",
          "key" : "text/sgml"
        }, {
          "description" : "Shockwave Flash Movie",
          "key" : "application/x-shockwave-flash"
        }, {
          "description" : "Signed Multipart",
          "key" : "multipart/signed"
        }, {
          "description" : "Survey",
          "key" : "application/vnd.ofbiz.survey"
        }, {
          "description" : "Survey Response",
          "key" : "application/vnd.ofbiz.survey.response"
        }, {
          "description" : "TIFF Image",
          "key" : "image/tiff"
        }, {
          "description" : "Tab Separated Value Text",
          "key" : "text/tab-separated-values"
        }, {
          "description" : "VRML Model",
          "key" : "model/vrml"
        }, {
          "description" : "Vorbis Audio",
          "key" : "audio/vorbis"
        }, {
          "description" : "WAV Audio",
          "key" : "audio/wav"
        }, {
          "description" : "WAX Audio",
          "key" : "audio/x-ms-wax"
        }, {
          "description" : "WM Video",
          "key" : "video/x-ms-wm"
        }, {
          "description" : "WMV Video",
          "key" : "video/x-ms-wmv"
        }, {
          "description" : "WMX Video",
          "key" : "video/x-ms-wmx"
        }, {
          "description" : "WVX Video",
          "key" : "video/x-ms-wvx"
        }, {
          "description" : "XML Text",
          "key" : "text/xml"
        }, {
          "description" : "ZIP Data",
          "key" : "application/zip"
        }, {
          "description" : "ZIP compressed file",
          "key" : "application/x-zip-compressed"
        }, {
          "description" : "diff for patching files",
          "key" : "text/x-diff"
        }, {
          "description" : "electronic business card",
          "key" : "text/x-vcard"
        } ],
        "disabled" : "false",
        "id" : "FindContent_mimeTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "mimeTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "FindContent",
          "id" : "FindContent_dataResourceId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupDataResource",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "dataResourceId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "dataResourceId",
        "style" : "",
        "id" : "FindContent_dataResourceId",
        "title" : "Data Resource ID",
        "type" : "lookup"
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "FindContent",
          "id" : "FindContent_ownerContentId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupContent",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "ownerContentId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "ownerContentId",
        "style" : "",
        "id" : "FindContent_ownerContentId",
        "title" : "Owner Content ID",
        "type" : "lookup"
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Status ID",
        "type" : "dropdown",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "FindContent",
        "allOptionValues" : [ {
          "description" : "Available",
          "key" : "CTNT_AVAILABLE"
        }, {
          "description" : "Deactivated",
          "key" : "CTNT_DEACTIVATED"
        }, {
          "description" : "Final Draft",
          "key" : "CTNT_FINAL_DRAFT"
        }, {
          "description" : "In Progress",
          "key" : "CTNT_IN_PROGRESS"
        }, {
          "description" : "Initial Draft",
          "key" : "CTNT_INITIAL_DRAFT"
        }, {
          "description" : "Published",
          "key" : "CTNT_PUBLISHED"
        }, {
          "description" : "Revised Draft",
          "key" : "CTNT_REVISED_DRAFT"
        } ],
        "disabled" : "false",
        "id" : "FindContent_statusId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "multiple",
        "partialSearch" : "",
        "size" : "1",
        "name" : "statusId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "FindContent",
          "id" : "FindContent_createdByUserLogin",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupUserLoginAndPartyDetails",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "createdByUserLogin",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "createdByUserLogin",
        "style" : "",
        "id" : "FindContent_createdByUserLogin",
        "title" : "Created By User",
        "type" : "lookup"
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "FindContent",
          "id" : "FindContent_localeString",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupLocale",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "localeString",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "localeString",
        "style" : "",
        "id" : "FindContent_localeString",
        "title" : "Locale String",
        "type" : "lookup"
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "FindContent",
        "tabindex" : "",
        "name" : "searchButton",
        "className" : "smallSubmit",
        "id" : "FindContent_searchButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "Find",
        "event" : "",
        "imgSrc" : ""
      } ],
    },  
    {
      "name" : "EditContentRest",
      "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
      "targets":{
        createTarget:"createContent",
        updateTarget:"updateContent"
      },
      "titleDescriptionField":"contentName",
      "idFieldName":"contentId",
      "fields" : [ {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Content ID",
        "type" : "hidden",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "contentId",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_contentId",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Content Type ID",
        "type" : "dropdown",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditContentRest",
        "allOptionValues" : [ {
          "description" : "Annotation",
          "key" : "ANNOTATION"
        }, {
          "description" : "Birt report (.rptDesign) file",
          "key" : "RPTDESIGN"
        }, {
          "description" : "Blog Root",
          "key" : "BLOG_ROOT"
        }, {
          "description" : "Content List",
          "key" : "CONTENT_LIST"
        }, {
          "description" : "Decorator",
          "key" : "DECORATOR"
        }, {
          "description" : "Department",
          "key" : "DEPARTMENT"
        }, {
          "description" : "Document",
          "key" : "DOCUMENT"
        }, {
          "description" : "FAQ Root",
          "key" : "FAQ_ROOT"
        }, {
          "description" : "Forum root publish point",
          "key" : "FORUM_ROOT"
        }, {
          "description" : "Frame Image",
          "key" : "IMAGE_FRAME"
        }, {
          "description" : "Graph Root",
          "key" : "GRAPH_ROOT"
        }, {
          "description" : "Menu Container",
          "key" : "MENU_CONTAINER"
        }, {
          "description" : "Outline Node",
          "key" : "OUTLINE_NODE"
        }, {
          "description" : "Page Node",
          "key" : "PAGE_NODE"
        }, {
          "description" : "People",
          "key" : "PEOPLE"
        }, {
          "description" : "Person",
          "key" : "PERSON"
        }, {
          "description" : "Place Holder",
          "key" : "PLACEHOLDER"
        }, {
          "description" : "Publish Point",
          "key" : "WEB_SITE_PUB_PT"
        }, {
          "description" : "Report",
          "key" : "FLEXIBLE_REPORT"
        }, {
          "description" : "Report Master",
          "key" : "REPORT_MASTER"
        }, {
          "description" : "Structure Definition (like DTD)",
          "key" : "STRUCTURE_DEF"
        }, {
          "description" : "Structure Leaf",
          "key" : "STRUCTURE_LEAF"
        }, {
          "description" : "Structure Node",
          "key" : "STRUCTURE_NODE"
        }, {
          "description" : "Sub Page Node",
          "key" : "SUBPAGE_NODE"
        }, {
          "description" : "Template or Form",
          "key" : "TEMPLATE"
        }, {
          "description" : "Topic",
          "key" : "TOPIC"
        }, {
          "description" : "Transformation Definition (like XSLT)",
          "key" : "TXFORM_DEF"
        }, {
          "description" : "Tree Root",
          "key" : "TREE_ROOT"
        } ],
        "disabled" : "false",
        "id" : "EditContent_contentTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "contentTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "entityName": "Content",
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "contentId","contentName" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditContentRest",
          "id" : "EditContent_ownerContentId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupContent",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "ownerContentId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "ownerContentId",
        "style" : "",
        "id" : "EditContent_ownerContentId",
        "title" : "Owner Content ID",
        "type" : "lookup"
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "entityName": "Content",
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "contentId","contentName" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditContentRest",
          "id" : "EditContent_decoratorContentId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupContent",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "decoratorContentId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "decoratorContentId",
        "style" : "",
        "id" : "EditContent_decoratorContentId",
        "title" : "Decorator Content ID",
        "type" : "lookup"
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "20",
        "ajaxUrl" : "",
        "maxlength" : "20",
        "tabindex" : "",
        "className" : "",
        "title" : "Instance Of Content ID",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "instanceOfContentId",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_instanceOfContentId",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "entityName":"DataResource",
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "dataResourceId","dataResourceName" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditContentRest",
          "id" : "EditContent_dataResourceId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupDataResource",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "dataResourceId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "dataResourceId",
        "style" : "",
        "id" : "EditContent_dataResourceId",
        "title" : "Data Resource ID",
        "type" : "lookup"
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "entityName":"DataResource",
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "dataResourceId","dataResourceName" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditContentRest",
          "id" : "EditContent_templateDataResourceId",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupDataResource",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "templateDataResourceId",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "templateDataResourceId",
        "style" : "",
        "id" : "EditContent_templateDataResourceId",
        "title" : "Template Data Resource ID",
        "type" : "lookup"
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "20",
        "ajaxUrl" : "",
        "maxlength" : "20",
        "tabindex" : "",
        "className" : "",
        "title" : "Data Source ID",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "dataSourceId",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_dataSourceId",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "20",
        "ajaxUrl" : "",
        "maxlength" : "20",
        "tabindex" : "",
        "className" : "",
        "title" : "Privilege Enum ID",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "privilegeEnumId",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_privilegeEnumId",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "250",
        "tabindex" : "",
        "className" : "",
        "title" : "Service Name",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "serviceName",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_serviceName",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "20",
        "ajaxUrl" : "",
        "maxlength" : "20",
        "tabindex" : "",
        "className" : "",
        "title" : "Custom Method ID",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "customMethodId",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_customMethodId",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "250",
        "tabindex" : "",
        "className" : "",
        "title" : "Content Name",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "contentName",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_contentName",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "250",
        "tabindex" : "",
        "className" : "",
        "title" : "Description",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_description",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "fieldHelpText" : "",
        "lookupOptions" : {
          "entityName":"Locale",
          "ajaxUrl" : "",
          "fadeBackground" : "true",
          "conditionGroup" : "",
          "targetParameterList" : [ "" ],
          "className" : "",
          "type" : "lookup",
          "presentation" : "layer",
          "initiallyCollapsed" : "false",
          "ajaxEnabled" : "true",
          "showDescription" : "true",
          "delegatorName" : "",
          "readonly" : "false",
          "alert" : "false",
          "formName" : "EditContentRest",
          "id" : "EditContent_localeString",
          "event" : "",
          "value" : "",
          "fieldFormName" : "LookupLocale",
          "maxlength" : "",
          "autocomplete" : "",
          "clearText" : "Clear",
          "tabindex" : "",
          "size" : "25",
          "name" : "localeString",
          "descriptionFieldName" : "",
          "position" : "topleft",
          "imgSrc" : ""
        },
        "name" : "localeString",
        "style" : "",
        "id" : "EditContent_localeString",
        "title" : "Locale String",
        "type" : "lookup"
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Mime Type ID",
        "type" : "dropdown",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "Y",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditContentRest",
        "allOptionValues" : [ {
          "description" : "application/msword - Microsoft Word",
          "key" : "application/msword"
        }, {
          "description" : "application/octet-stream - Arbitrary Binary Data",
          "key" : "application/octet-stream"
        }, {
          "description" : "application/pdf - Adobe Portable Document Format (PDF)",
          "key" : "application/pdf"
        }, {
          "description" : "application/pkcs7-signature - PKCS7 Signature",
          "key" : "application/pkcs7-signature"
        }, {
          "description" : "application/postscript - Post script Application/Script",
          "key" : "application/postscript"
        }, {
          "description" : "application/vnd.ms-excel - Microsoft Excel",
          "key" : "application/vnd.ms-excel"
        }, {
          "description" : "application/vnd.ms-powerpoint - Microsoft PowerPoint",
          "key" : "application/vnd.ms-powerpoint"
        }, {
          "description" : "application/vnd.oasis.opendocument.spreadsheet - OpenOffice OpenDocument Spreadsheet",
          "key" : "application/vnd.oasis.opendocument.spreadsheet"
        }, {
          "description" : "application/vnd.oasis.opendocument.text - OpenOffice OpenDocument Text",
          "key" : "application/vnd.oasis.opendocument.text"
        }, {
          "description" : "application/vnd.ofbiz.survey - Survey",
          "key" : "application/vnd.ofbiz.survey"
        }, {
          "description" : "application/vnd.ofbiz.survey.response - Survey Response",
          "key" : "application/vnd.ofbiz.survey.response"
        }, {
          "description" : "application/x-shockwave-flash - Shockwave Flash Movie",
          "key" : "application/x-shockwave-flash"
        }, {
          "description" : "application/x-tgz - Gzipped Tar archive file",
          "key" : "application/x-tgz"
        }, {
          "description" : "application/x-zip-compressed - ZIP compressed file",
          "key" : "application/x-zip-compressed"
        }, {
          "description" : "application/zip - ZIP Data",
          "key" : "application/zip"
        }, {
          "description" : "audio/basic - Basic Audio",
          "key" : "audio/basic"
        }, {
          "description" : "audio/flac - FLAC Audio",
          "key" : "audio/flac"
        }, {
          "description" : "audio/mp4 - MP4 Audio",
          "key" : "audio/mp4"
        }, {
          "description" : "audio/mpeg - MPEG Audio",
          "key" : "audio/mpeg"
        }, {
          "description" : "audio/ogg - OGG Audio",
          "key" : "audio/ogg"
        }, {
          "description" : "audio/vorbis - Vorbis Audio",
          "key" : "audio/vorbis"
        }, {
          "description" : "audio/wav - WAV Audio",
          "key" : "audio/wav"
        }, {
          "description" : "audio/x-flac - FLAC Audio",
          "key" : "audio/x-flac"
        }, {
          "description" : "audio/x-ms-wax - WAX Audio",
          "key" : "audio/x-ms-wax"
        }, {
          "description" : "audio/x-ogg - OGG Audio",
          "key" : "audio/x-ogg"
        }, {
          "description" : "image/gif - GIF Image",
          "key" : "image/gif"
        }, {
          "description" : "image/jpeg - JPEG/JPG Image",
          "key" : "image/jpeg"
        }, {
          "description" : "image/pjpeg - Progressive JPEG/JPG Image",
          "key" : "image/pjpeg"
        }, {
          "description" : "image/png - PNG Image",
          "key" : "image/png"
        }, {
          "description" : "image/svg+xml - Image SVG",
          "key" : "image/svg+xml"
        }, {
          "description" : "image/tiff - TIFF Image",
          "key" : "image/tiff"
        }, {
          "description" : "message/external-body - External Body Message",
          "key" : "message/external-body"
        }, {
          "description" : "message/http - HTTP Message",
          "key" : "message/http"
        }, {
          "description" : "message/news - News Message",
          "key" : "message/news"
        }, {
          "description" : "message/partial - Partial Message",
          "key" : "message/partial"
        }, {
          "description" : "message/rfc822 - RFC 822 Headered Message",
          "key" : "message/rfc822"
        }, {
          "description" : "message/s-http - HTTPS/S-HTTP Message",
          "key" : "message/s-http"
        }, {
          "description" : "model/mesh - Mesh Model",
          "key" : "model/mesh"
        }, {
          "description" : "model/vrml - VRML Model",
          "key" : "model/vrml"
        }, {
          "description" : "multipart/alternative - Mutliple Alternative Multipart",
          "key" : "multipart/alternative"
        }, {
          "description" : "multipart/digest - Digest of Messages Multipart",
          "key" : "multipart/digest"
        }, {
          "description" : "multipart/encrypted - Encrypted Multipart",
          "key" : "multipart/encrypted"
        }, {
          "description" : "multipart/form-data - Form Data Multipart",
          "key" : "multipart/form-data"
        }, {
          "description" : "multipart/mixed - Mixed Type Multipart",
          "key" : "multipart/mixed"
        }, {
          "description" : "multipart/related - Related Multipart",
          "key" : "multipart/related"
        }, {
          "description" : "multipart/signed - Signed Multipart",
          "key" : "multipart/signed"
        }, {
          "description" : "text/css - CSS Text",
          "key" : "text/css"
        }, {
          "description" : "text/csv - Comma Separated Value Text ",
          "key" : "text/csv"
        }, {
          "description" : "text/enriched - Enriched Text",
          "key" : "text/enriched"
        }, {
          "description" : "text/html - HTML Text",
          "key" : "text/html"
        }, {
          "description" : "text/plain - Plain Text",
          "key" : "text/plain"
        }, {
          "description" : "text/richtext - Rich Text",
          "key" : "text/richtext"
        }, {
          "description" : "text/rtf - RTF Rich Text",
          "key" : "text/rtf"
        }, {
          "description" : "text/sgml - SGML Text",
          "key" : "text/sgml"
        }, {
          "description" : "text/tab-separated-values - Tab Separated Value Text",
          "key" : "text/tab-separated-values"
        }, {
          "description" : "text/x-diff - diff for patching files",
          "key" : "text/x-diff"
        }, {
          "description" : "text/x-vcard - electronic business card",
          "key" : "text/x-vcard"
        }, {
          "description" : "text/xml - XML Text",
          "key" : "text/xml"
        }, {
          "description" : "video/3gpp - 3GP Mobile Video",
          "key" : "video/3gpp"
        }, {
          "description" : "video/avi - AVI Video",
          "key" : "video/avi"
        }, {
          "description" : "video/mp4 - MPEG-4 (H.264) Video",
          "key" : "video/mp4"
        }, {
          "description" : "video/mpeg - MPEG/MPG Video",
          "key" : "video/mpeg"
        }, {
          "description" : "video/quicktime - Quicktime Video",
          "key" : "video/quicktime"
        }, {
          "description" : "video/x-flv - Flash Streaming Video",
          "key" : "video/x-flv"
        }, {
          "description" : "video/x-ms-asf - ASF Video",
          "key" : "video/x-ms-asf"
        }, {
          "description" : "video/x-ms-wm - WM Video",
          "key" : "video/x-ms-wm"
        }, {
          "description" : "video/x-ms-wmv - WMV Video",
          "key" : "video/x-ms-wmv"
        }, {
          "description" : "video/x-ms-wmx - WMX Video",
          "key" : "video/x-ms-wmx"
        }, {
          "description" : "video/x-ms-wvx - WVX Video",
          "key" : "video/x-ms-wvx"
        } ],
        "disabled" : "false",
        "id" : "EditContent_mimeTypeId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "mimeTypeId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "fieldName" : "",
        "firstInList" : "",
        "partialChars" : "",
        "conditionGroup" : "",
        "otherFieldName" : "",
        "className" : "",
        "title" : "Character Set ID",
        "type" : "dropdown",
        "frequency" : "",
        "minChars" : "",
        "allowEmpty" : "Y",
        "autoSelect" : "",
        "ajaxEnabled" : "false",
        "noCurrentSelectedKey" : "",
        "ajaxOptions" : "",
        "alert" : "false",
        "otherFieldSize" : "0",
        "ignoreCase" : "",
        "formName" : "EditContentRest",
        "allOptionValues" : [ {
          "description" : "ISO-8859-1",
          "key" : "ISO-8859-1"
        }, {
          "description" : "ISO-8859-2",
          "key" : "ISO-8859-2"
        }, {
          "description" : "ISO-8859-3",
          "key" : "ISO-8859-3"
        }, {
          "description" : "ISO-8859-4",
          "key" : "ISO-8859-4"
        }, {
          "description" : "ISO-8859-5",
          "key" : "ISO-8859-5"
        }, {
          "description" : "ISO-8859-6",
          "key" : "ISO-8859-6"
        }, {
          "description" : "ISO-8859-7",
          "key" : "ISO-8859-7"
        }, {
          "description" : "ISO-8859-8",
          "key" : "ISO-8859-8"
        }, {
          "description" : "ISO-8859-9",
          "key" : "ISO-8859-9"
        }, {
          "description" : "ISO-8859-10",
          "key" : "ISO-8859-10"
        }, {
          "description" : "US-ASCII",
          "key" : "US-ASCII"
        }, {
          "description" : "UTF-8",
          "key" : "UTF-8"
        }, {
          "description" : "UTF-16",
          "key" : "UTF-16"
        } ],
        "disabled" : "false",
        "id" : "EditContent_characterSetId",
        "event" : "",
        "otherValue" : "",
        "fullSearch" : "",
        "fieldHelpText" : "",
        "dDFCurrent" : "selected",
        "tabindex" : "",
        "multiple" : "",
        "partialSearch" : "",
        "size" : "1",
        "name" : "characterSetId",
        "style" : "",
        "explicitDescription" : "",
        "choices" : "",
        "currentValue" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "6",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Child Leaf Count",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "childLeafCount",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_childLeafCount",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "6",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Child Branch Count",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "childBranchCount",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_childBranchCount",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "classString" : "",
        "shortDateInput" : "false",
        "ampmName" : "",
        "className" : "",
        "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
        "type" : "datetime",
        "dateType" : "timestamp",
        "defaultDateTimeString" : "2022-09-14%2009:50:36.277",
        "timeDropdown" : "",
        "alert" : "false",
        "timeValues" : "",
        "formName" : "EditContentRest",
        "timeDropdownParamName" : "createdDate",
        "timeMinutesName" : "",
        "disabled" : "false",
        "id" : "EditContent_createdDate",
        "event" : "",
        "value" : "",
        "pmSelected" : "",
        "mask" : "",
        "hour1" : "0",
        "isTwelveHour" : "false",
        "fieldHelpText" : "",
        "hour2" : "0",
        "maxlength" : "30",
        "minutes" : "0",
        "tabindex" : "",
        "amSelected" : "",
        "size" : "25",
        "isXMLHttpRequest" : "false",
        "localizedIconTitle" : "View Calendar",
        "timeHourName" : "",
        "name" : "createdDate",
        "style" : "",
        "step" : "1",
        "compositeType" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "250",
        "tabindex" : "",
        "className" : "",
        "title" : "Created By User",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "createdByUserLogin",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_createdByUserLogin",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "classString" : "",
        "shortDateInput" : "false",
        "ampmName" : "",
        "className" : "",
        "title" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
        "type" : "DATE_TIME",
        "dateType" : "timestamp",
        "defaultDateTimeString" : "2022-09-14%2009:50:36.278",
        "timeDropdown" : "",
        "alert" : "false",
        "timeValues" : "",
        "formName" : "EditContentRest",
        "timeDropdownParamName" : "lastModifiedDate",
        "timeMinutesName" : "",
        "disabled" : "false",
        "id" : "EditContent_lastModifiedDate",
        "event" : "",
        "value" : "",
        "pmSelected" : "",
        "mask" : "",
        "hour1" : "0",
        "isTwelveHour" : "false",
        "fieldHelpText" : "",
        "hour2" : "0",
        "maxlength" : "30",
        "minutes" : "0",
        "tabindex" : "",
        "amSelected" : "",
        "size" : "25",
        "isXMLHttpRequest" : "false",
        "localizedIconTitle" : "View Calendar",
        "timeHourName" : "",
        "name" : "lastModifiedDate",
        "style" : "",
        "step" : "1",
        "compositeType" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "60",
        "ajaxUrl" : "",
        "maxlength" : "250",
        "tabindex" : "",
        "className" : "",
        "title" : "Last Modified By User",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "lastModifiedByUserLogin",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditContent_lastModifiedByUserLogin",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "EditContentRest",
        "tabindex" : "",
        "name" : "createButton",
        "className" : "smallSubmit",
        "id" : "EditContent_createButton",
        "confirmation" : "",
        "type" : "submit",
        "title" : "Create",
        "event" : "",
        "imgSrc" : ""
      } ],
      "target" : "updateContent"
    },
    {
      "name" : "ListContentRest",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "contentId",
        "action" : "",
        "id" : "ListContent_contentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "hyperlink" : {
          "linkStyle" : "buttontext",
          "description" : "[]",
          "targetType" : "intra-app",
          "confirmation" : "",
          "parameterMap" : {
            "VIEW_SIZE_0" : "20",
            "VIEW_INDEX_0" : "0"
          },
          "uniqueItemName" : "Modal_f6c5d5b0_7023_47d0_909c_baf1cbcbabbd",
          "target" : "editContent",
          "targetWindow" : ""
        },
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "contentName",
        "description" : "",
        "style" : "",
        "id" : "ListContent_contentName",
        "type" : "display-entity",
        "title" : "Content Name",
        "imageLocation" : "",
        "parameterList":[
          {"name":"contentId"}
        ],
        "formData":{
          "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
          "formName":"EditContentRest",
          "endPoint":"listFindWebSiteContent"
        },
        "event":"edit"
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "description",
        "description" : "",
        "style" : "",
        "id" : "ListContent_description",
        "type" : "display",
        "title" : "Description",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "statusId",
        "description" : "",
        "style" : "",
        "id" : "ListContent_statusId",
        "type" : "display-entity",
        "title" : "Status ID",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "localeString",
        "description" : "",
        "style" : "",
        "id" : "ListContent_localeString",
        "type" : "display-entity",
        "title" : "Locale String",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "contentTypeId",
        "description" : "",
        "style" : "",
        "id" : "ListContent_contentTypeId",
        "type" : "display-entity",
        "title" : "Content Type ID",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "mimeTypeId",
        "description" : "",
        "style" : "",
        "id" : "ListContent_mimeTypeId",
        "type" : "display-entity",
        "title" : "Mime Type ID",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "dataResourceId",
        "description" : "",
        "style" : "",
        "id" : "ListContent_dataResourceId",
        "type" : "display-entity",
        "title" : "Data Resource ID",
        "imageLocation" : "",
        "entityName":"DataResourceId",
        "parameterList":[
          {"name":"contentId"}
        ]
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "ownerContentId",
        "description" : "",
        "style" : "",
        "id" : "ListContent_ownerContentId",
        "type" : "display",
        "title" : "Owner Content ID",
        "imageLocation" : ""
      }, {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "isSortField" : "Y",
        "size" : 0,
        "name" : "createdByUserLogin",
        "description" : "",
        "style" : "",
        "id" : "ListContent_createdByUserLogin",
        "type" : "display",
        "title" : "Created By User",
        "imageLocation" : ""
      } ],
      "target" : ""
    },
    {
      "name":"ListContent",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Content Id",
          "name": "contentId",
          "value": "",
          "id": "ListContent_contentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Name",
          "name": "contentName",
          "value": "",
          "id": "ListContent_contentName",
          "event": "view",
          "required": false,
          "type": "display-entity",
          "entityName": "Content",
          "description": "",
          "parameterList": [
            {
              "name": "contentId"
            }
          ]
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "ListContent_description",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "ListContent_statusId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "StatusItem",
          "description": ""
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "ListContent_localeString",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "CountryCode",
          "description": ""
        },
        {
          "title": "Content Type Id",
          "name": "contentTypeId",
          "value": "",
          "id": "ListContent_contentTypeId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "ContentType",
          "description": ""
        },
        {
          "title": "Mime Type Id",
          "name": "mimeTypeId",
          "value": "",
          "id": "ListContent_mimeTypeId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "MimeType",
          "description": ""
        },
        {
          "title": "ContentDataResourceId",
          "name": "dataResourceId",
          "value": "",
          "id": "ListContent_dataResourceId",
          "event": "view",
          "required": false,
          "type": "display-entity",
          "entityName": "DataResource",
          "description": "",
          "parameterList": [
            {
              "name": "dataResourceId"
            }
          ]
        },
        {
          "title": "Owner Content Id",
          "name": "ownerContentId",
          "value": "",
          "id": "ListContent_ownerContentId",
          "event": "view",
          "required": false,
          "type": "display-entity",
          "entityName": "Content",
          "description": "",
          "parameterList": [
            {
              "name": "contentId"
            }
          ]
        },
        {
          "title": "Created By User Login",
          "name": "createdByUserLogin",
          "value": "",
          "id": "ListContent_createdByUserLogin",
          "event": "",
          "required": false
        }
      ]

    },
    //DataResource
    {
      "name": "FindDataResource",
      "target": "findDataResource",
      "targetWindow": "",
      "fields": [
        {
          "title": "No Condition Find",
          "name": "noConditionFind",
          "value": "",
          "id": "FindDataResource_noConditionFind",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Data Resource Id",
          "name": "dataResourceId",
          "value": "",
          "id": "FindDataResource_dataResourceId",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Data Resource Name",
          "name": "dataResourceName",
          "value": "",
          "id": "FindDataResource_dataResourceName",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Data Resource Type Id",
          "name": "dataResourceTypeId",
          "value": "",
          "id": "FindDataResource_dataResourceTypeId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "AUDIO_OBJECT",
              "description": "Audio"
            },
            {
              "key": "OFBIZ_FILE_BIN",
              "description": "Binary File (rel to OFBIZ_HOME)"
            },
            {
              "key": "CONTEXT_FILE_BIN",
              "description": "Binary File (rel to webapp root)"
            },
            {
              "key": "OFBIZ_FILE",
              "description": "File (rel to OFBIZ_HOME)"
            },
            {
              "key": "CONTEXT_FILE",
              "description": "File (rel to webapp root)"
            },
            {
              "key": "LINK",
              "description": "HyperLink"
            },
            {
              "key": "IMAGE_OBJECT",
              "description": "Image"
            },
            {
              "key": "LOCAL_FILE_BIN",
              "description": "Local Binary File"
            },
            {
              "key": "LOCAL_FILE",
              "description": "Local File"
            },
            {
              "key": "ELECTRONIC_TEXT",
              "description": "Long Text"
            },
            {
              "key": "OTHER_OBJECT",
              "description": "Other"
            },
            {
              "key": "SHORT_TEXT",
              "description": "Short Text"
            },
            {
              "key": "SURVEY",
              "description": "Survey"
            },
            {
              "key": "SURVEY_RESPONSE",
              "description": "Survey Response"
            },
            {
              "key": "URL_RESOURCE",
              "description": "URL Resource"
            },
            {
              "key": "VIDEO_OBJECT",
              "description": "Video"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Mime Type Id",
          "name": "mimeTypeId",
          "value": "",
          "id": "FindDataResource_mimeTypeId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "application/msword",
              "description": "application/msword - Microsoft Word"
            },
            {
              "key": "application/octet-stream",
              "description": "application/octet-stream - Arbitrary Binary Data"
            },
            {
              "key": "application/pdf",
              "description": "application/pdf - Adobe Portable Document Format (PDF)"
            },
            {
              "key": "application/pkcs7-signature",
              "description": "application/pkcs7-signature - PKCS7 Signature"
            },
            {
              "key": "application/postscript",
              "description": "application/postscript - Post script Application/Script"
            },
            {
              "key": "application/vnd.ms-excel",
              "description": "application/vnd.ms-excel - Microsoft Excel"
            },
            {
              "key": "application/vnd.ms-powerpoint",
              "description": "application/vnd.ms-powerpoint - Microsoft PowerPoint"
            },
            {
              "key": "application/vnd.oasis.opendocument.spreadsheet",
              "description": "application/vnd.oasis.opendocument.spreadsheet - OpenOffice OpenDocument Spreadsheet"
            },
            {
              "key": "application/vnd.oasis.opendocument.text",
              "description": "application/vnd.oasis.opendocument.text - OpenOffice OpenDocument Text"
            },
            {
              "key": "application/vnd.ofbiz.survey",
              "description": "application/vnd.ofbiz.survey - Survey"
            },
            {
              "key": "application/vnd.ofbiz.survey.response",
              "description": "application/vnd.ofbiz.survey.response - Survey Response"
            },
            {
              "key": "application/x-shockwave-flash",
              "description": "application/x-shockwave-flash - Shockwave Flash Movie"
            },
            {
              "key": "application/x-tgz",
              "description": "application/x-tgz - Gzipped Tar archive file"
            },
            {
              "key": "application/x-zip-compressed",
              "description": "application/x-zip-compressed - ZIP compressed file"
            },
            {
              "key": "application/zip",
              "description": "application/zip - ZIP Data"
            },
            {
              "key": "audio/basic",
              "description": "audio/basic - Basic Audio"
            },
            {
              "key": "audio/mpeg",
              "description": "audio/mpeg - MPEG Audio"
            },
            {
              "key": "audio/x-ms-wax",
              "description": "audio/x-ms-wax - WAX Audio"
            },
            {
              "key": "audio/x-ms-wma",
              "description": "audio/x-ms-wma - WMA Audio"
            },
            {
              "key": "image/gif",
              "description": "image/gif - GIF Image"
            },
            {
              "key": "image/jpeg",
              "description": "image/jpeg - JPEG/JPG Image"
            },
            {
              "key": "image/pjpeg",
              "description": "image/pjpeg - Progressive JPEG/JPG Image"
            },
            {
              "key": "image/png",
              "description": "image/png - PNG Image"
            },
            {
              "key": "image/tiff",
              "description": "image/tiff - TIFF Image"
            },
            {
              "key": "message/external-body",
              "description": "message/external-body - External Body Message"
            },
            {
              "key": "message/http",
              "description": "message/http - HTTP Message"
            },
            {
              "key": "message/news",
              "description": "message/news - News Message"
            },
            {
              "key": "message/partial",
              "description": "message/partial - Partial Message"
            },
            {
              "key": "message/rfc822",
              "description": "message/rfc822 - RFC 822 Headered Message"
            },
            {
              "key": "message/s-http",
              "description": "message/s-http - HTTPS/S-HTTP Message"
            },
            {
              "key": "model/mesh",
              "description": "model/mesh - Mesh Model"
            },
            {
              "key": "model/vrml",
              "description": "model/vrml - VRML Model"
            },
            {
              "key": "multipart/alternative",
              "description": "multipart/alternative - Mutliple Alternative Multipart"
            },
            {
              "key": "multipart/digest",
              "description": "multipart/digest - Digest of Messages Multipart"
            },
            {
              "key": "multipart/encrypted",
              "description": "multipart/encrypted - Encrypted Multipart"
            },
            {
              "key": "multipart/form-data",
              "description": "multipart/form-data - Form Data Multipart"
            },
            {
              "key": "multipart/mixed",
              "description": "multipart/mixed - Mixed Type Multipart"
            },
            {
              "key": "multipart/related",
              "description": "multipart/related - Related Multipart"
            },
            {
              "key": "multipart/signed",
              "description": "multipart/signed - Signed Multipart"
            },
            {
              "key": "text/css",
              "description": "text/css - CSS Text"
            },
            {
              "key": "text/csv",
              "description": "text/csv - Comma Separated Value Text "
            },
            {
              "key": "text/enriched",
              "description": "text/enriched - Enriched Text"
            },
            {
              "key": "text/html",
              "description": "text/html - HTML Text"
            },
            {
              "key": "text/plain",
              "description": "text/plain - Plain Text"
            },
            {
              "key": "text/richtext",
              "description": "text/richtext - Rich Text"
            },
            {
              "key": "text/rtf",
              "description": "text/rtf - RTF Rich Text"
            },
            {
              "key": "text/sgml",
              "description": "text/sgml - SGML Text"
            },
            {
              "key": "text/tab-separated-values",
              "description": "text/tab-separated-values - Tab Separated Value Text"
            },
            {
              "key": "text/x-diff",
              "description": "text/x-diff - diff for patching files"
            },
            {
              "key": "text/x-vcard",
              "description": "text/x-vcard - electronic business card"
            },
            {
              "key": "text/xml",
              "description": "text/xml - XML Text"
            },
            {
              "key": "video/avi",
              "description": "video/avi - AVI Video"
            },
            {
              "key": "video/mp4",
              "description": "video/mp4 - MPEG-4 (H.264) Video"
            },
            {
              "key": "video/mpeg",
              "description": "video/mpeg - MPEG/MPG Video"
            },
            {
              "key": "video/quicktime",
              "description": "video/quicktime - Quicktime Video"
            },
            {
              "key": "video/x-flv",
              "description": "video/x-flv - Flash Streaming Video"
            },
            {
              "key": "video/x-ms-asf",
              "description": "video/x-ms-asf - ASF Video"
            },
            {
              "key": "video/x-ms-wm",
              "description": "video/x-ms-wm - WM Video"
            },
            {
              "key": "video/x-ms-wmv",
              "description": "video/x-ms-wmv - WMV Video"
            },
            {
              "key": "video/x-ms-wmx",
              "description": "video/x-ms-wmx - WMX Video"
            },
            {
              "key": "video/x-ms-wvx",
              "description": "video/x-ms-wvx - WVX Video"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "FindDataResource_statusId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "CTNT_AVAILABLE",
              "description": "Available"
            },
            {
              "key": "CTNT_DEACTIVATED",
              "description": "Deactivated"
            },
            {
              "key": "CTNT_FINAL_DRAFT",
              "description": "Final Draft"
            },
            {
              "key": "CTNT_IN_PROGRESS",
              "description": "In Progress"
            },
            {
              "key": "CTNT_INITIAL_DRAFT",
              "description": "Initial Draft"
            },
            {
              "key": "CTNT_PUBLISHED",
              "description": "Published"
            },
            {
              "key": "CTNT_REVISED_DRAFT",
              "description": "Revised Draft"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "FindDataResource_localeString",
          "event": "",
          "required": false,
          "type": "lookup",
          "formName": "LookupLocale"
        },
        {
          "title": "Created By User Login",
          "name": "createdByUserLogin",
          "value": "",
          "id": "FindDataResource_createdByUserLogin",
          "event": "",
          "required": false,
          "type": "lookup",
          "formName": "LookupPerson"
        },
        {
          "title": "Data Category Id",
          "name": "dataCategoryId",
          "value": "",
          "id": "FindDataResource_dataCategoryId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "ROOT",
              "description": "ROOT"
            },
            {
              "key": "BUSINESS",
              "description": "Business"
            },
            {
              "key": "FINANCIAL",
              "description": "Financial"
            },
            {
              "key": "TECH_HARD",
              "description": "Hardware"
            },
            {
              "key": "TECH_SOFT_JAVA",
              "description": "Java"
            },
            {
              "key": "LEGAL",
              "description": "Legal"
            },
            {
              "key": "TECH_SOFT_LINUX",
              "description": "Linux"
            },
            {
              "key": "BUS_MANU",
              "description": "Manufacturing"
            },
            {
              "key": "TECH_SOFT_OFBIZ",
              "description": "Open for Business"
            },
            {
              "key": "PERSONAL",
              "description": "Personal"
            },
            {
              "key": "POLITICAL",
              "description": "Political"
            },
            {
              "key": "BUS_RETAIL",
              "description": "Retail"
            },
            {
              "key": "TECH_SERV",
              "description": "Service"
            },
            {
              "key": "BUS_SERVICE",
              "description": "Service"
            },
            {
              "key": "TECH_SOFT",
              "description": "Software"
            },
            {
              "key": "TECHNOLOGY",
              "description": "Technology"
            },
            {
              "key": "TEMPLATE",
              "description": "Template"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Find",
          "name": "searchButton",
          "value": "",
          "id": "FindDataResource_searchButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"EditDataResource",
      "target": "updateDataResource",
      "targetWindow": "",
      "fields": [
        {
          "title": "Data Resource Id",
          "name": "dataResourceId",
          "value": "",
          "id": "EditDataResource_dataResourceId",
          "event": "",
          "required": false
        },
        {
          "title": "Data Resource Id",
          "name": "dataResourceId",
          "value": "",
          "id": "EditDataResource_dataResourceId",
          "event": "",
          "required": false
        },
        {
          "title": "Data Resource Type Id",
          "name": "dataResourceTypeId",
          "value": "",
          "id": "EditDataResource_dataResourceTypeId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "AUDIO_OBJECT",
              "description": "Audio"
            },
            {
              "key": "OFBIZ_FILE_BIN",
              "description": "Binary File (rel to OFBIZ_HOME)"
            },
            {
              "key": "CONTEXT_FILE_BIN",
              "description": "Binary File (rel to webapp root)"
            },
            {
              "key": "OFBIZ_FILE",
              "description": "File (rel to OFBIZ_HOME)"
            },
            {
              "key": "CONTEXT_FILE",
              "description": "File (rel to webapp root)"
            },
            {
              "key": "LINK",
              "description": "HyperLink"
            },
            {
              "key": "IMAGE_OBJECT",
              "description": "Image"
            },
            {
              "key": "LOCAL_FILE_BIN",
              "description": "Local Binary File"
            },
            {
              "key": "LOCAL_FILE",
              "description": "Local File"
            },
            {
              "key": "ELECTRONIC_TEXT",
              "description": "Long Text"
            },
            {
              "key": "OTHER_OBJECT",
              "description": "Other"
            },
            {
              "key": "SHORT_TEXT",
              "description": "Short Text"
            },
            {
              "key": "SURVEY",
              "description": "Survey"
            },
            {
              "key": "SURVEY_RESPONSE",
              "description": "Survey Response"
            },
            {
              "key": "URL_RESOURCE",
              "description": "URL Resource"
            },
            {
              "key": "VIDEO_OBJECT",
              "description": "Video"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Data Template Type Id",
          "name": "dataTemplateTypeId",
          "value": "",
          "id": "EditDataResource_dataTemplateTypeId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "FTL",
              "description": "FreeMarker"
            },
            {
              "key": "NONE",
              "description": "No Template"
            },
            {
              "key": "SCREEN_COMBINED",
              "description": "Screen widget"
            },
            {
              "key": "VTL",
              "description": "Velocity"
            },
            {
              "key": "WM",
              "description": "WebMacro"
            },
            {
              "key": "XSLT",
              "description": "XSLT"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Data Category Id",
          "name": "dataCategoryId",
          "value": "",
          "id": "EditDataResource_dataCategoryId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [],
          "textSize": 0
        },
        {
          "title": "Data Source Id",
          "name": "dataSourceId",
          "value": "",
          "id": "EditDataResource_dataSourceId",
          "required": false,
          "type": "text"
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "EditDataResource_statusId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [],
          "textSize": 0
        },
        {
          "title": "Data Resource Name",
          "name": "dataResourceName",
          "value": "",
          "id": "EditDataResource_dataResourceName",
          "required": false,
          "type": "text"
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "EditDataResource_localeString",
          "required": false,
          "type": "lookup",
          "formName": "LookupLocale"
        },
        {
          "title": "Mime Type Id",
          "name": "mimeTypeId",
          "value": "",
          "id": "EditDataResource_mimeTypeId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "application/msword",
              "description": "application/msword - Microsoft Word"
            },
            {
              "key": "application/octet-stream",
              "description": "application/octet-stream - Arbitrary Binary Data"
            },
            {
              "key": "application/pdf",
              "description": "application/pdf - Adobe Portable Document Format (PDF)"
            },
            {
              "key": "application/pkcs7-signature",
              "description": "application/pkcs7-signature - PKCS7 Signature"
            },
            {
              "key": "application/postscript",
              "description": "application/postscript - Post script Application/Script"
            },
            {
              "key": "application/vnd.ms-excel",
              "description": "application/vnd.ms-excel - Microsoft Excel"
            },
            {
              "key": "application/vnd.ms-powerpoint",
              "description": "application/vnd.ms-powerpoint - Microsoft PowerPoint"
            },
            {
              "key": "application/vnd.oasis.opendocument.spreadsheet",
              "description": "application/vnd.oasis.opendocument.spreadsheet - OpenOffice OpenDocument Spreadsheet"
            },
            {
              "key": "application/vnd.oasis.opendocument.text",
              "description": "application/vnd.oasis.opendocument.text - OpenOffice OpenDocument Text"
            },
            {
              "key": "application/vnd.ofbiz.survey",
              "description": "application/vnd.ofbiz.survey - Survey"
            },
            {
              "key": "application/vnd.ofbiz.survey.response",
              "description": "application/vnd.ofbiz.survey.response - Survey Response"
            },
            {
              "key": "application/x-shockwave-flash",
              "description": "application/x-shockwave-flash - Shockwave Flash Movie"
            },
            {
              "key": "application/x-tgz",
              "description": "application/x-tgz - Gzipped Tar archive file"
            },
            {
              "key": "application/x-zip-compressed",
              "description": "application/x-zip-compressed - ZIP compressed file"
            },
            {
              "key": "application/zip",
              "description": "application/zip - ZIP Data"
            },
            {
              "key": "audio/basic",
              "description": "audio/basic - Basic Audio"
            },
            {
              "key": "audio/mpeg",
              "description": "audio/mpeg - MPEG Audio"
            },
            {
              "key": "audio/x-ms-wax",
              "description": "audio/x-ms-wax - WAX Audio"
            },
            {
              "key": "audio/x-ms-wma",
              "description": "audio/x-ms-wma - WMA Audio"
            },
            {
              "key": "image/gif",
              "description": "image/gif - GIF Image"
            },
            {
              "key": "image/jpeg",
              "description": "image/jpeg - JPEG/JPG Image"
            },
            {
              "key": "image/pjpeg",
              "description": "image/pjpeg - Progressive JPEG/JPG Image"
            },
            {
              "key": "image/png",
              "description": "image/png - PNG Image"
            },
            {
              "key": "image/tiff",
              "description": "image/tiff - TIFF Image"
            },
            {
              "key": "message/external-body",
              "description": "message/external-body - External Body Message"
            },
            {
              "key": "message/http",
              "description": "message/http - HTTP Message"
            },
            {
              "key": "message/news",
              "description": "message/news - News Message"
            },
            {
              "key": "message/partial",
              "description": "message/partial - Partial Message"
            },
            {
              "key": "message/rfc822",
              "description": "message/rfc822 - RFC 822 Headered Message"
            },
            {
              "key": "message/s-http",
              "description": "message/s-http - HTTPS/S-HTTP Message"
            },
            {
              "key": "model/mesh",
              "description": "model/mesh - Mesh Model"
            },
            {
              "key": "model/vrml",
              "description": "model/vrml - VRML Model"
            },
            {
              "key": "multipart/alternative",
              "description": "multipart/alternative - Mutliple Alternative Multipart"
            },
            {
              "key": "multipart/digest",
              "description": "multipart/digest - Digest of Messages Multipart"
            },
            {
              "key": "multipart/encrypted",
              "description": "multipart/encrypted - Encrypted Multipart"
            },
            {
              "key": "multipart/form-data",
              "description": "multipart/form-data - Form Data Multipart"
            },
            {
              "key": "multipart/mixed",
              "description": "multipart/mixed - Mixed Type Multipart"
            },
            {
              "key": "multipart/related",
              "description": "multipart/related - Related Multipart"
            },
            {
              "key": "multipart/signed",
              "description": "multipart/signed - Signed Multipart"
            },
            {
              "key": "text/css",
              "description": "text/css - CSS Text"
            },
            {
              "key": "text/csv",
              "description": "text/csv - Comma Separated Value Text "
            },
            {
              "key": "text/enriched",
              "description": "text/enriched - Enriched Text"
            },
            {
              "key": "text/html",
              "description": "text/html - HTML Text"
            },
            {
              "key": "text/plain",
              "description": "text/plain - Plain Text"
            },
            {
              "key": "text/richtext",
              "description": "text/richtext - Rich Text"
            },
            {
              "key": "text/rtf",
              "description": "text/rtf - RTF Rich Text"
            },
            {
              "key": "text/sgml",
              "description": "text/sgml - SGML Text"
            },
            {
              "key": "text/tab-separated-values",
              "description": "text/tab-separated-values - Tab Separated Value Text"
            },
            {
              "key": "text/x-diff",
              "description": "text/x-diff - diff for patching files"
            },
            {
              "key": "text/x-vcard",
              "description": "text/x-vcard - electronic business card"
            },
            {
              "key": "text/xml",
              "description": "text/xml - XML Text"
            },
            {
              "key": "video/avi",
              "description": "video/avi - AVI Video"
            },
            {
              "key": "video/mp4",
              "description": "video/mp4 - MPEG-4 (H.264) Video"
            },
            {
              "key": "video/mpeg",
              "description": "video/mpeg - MPEG/MPG Video"
            },
            {
              "key": "video/quicktime",
              "description": "video/quicktime - Quicktime Video"
            },
            {
              "key": "video/x-flv",
              "description": "video/x-flv - Flash Streaming Video"
            },
            {
              "key": "video/x-ms-asf",
              "description": "video/x-ms-asf - ASF Video"
            },
            {
              "key": "video/x-ms-wm",
              "description": "video/x-ms-wm - WM Video"
            },
            {
              "key": "video/x-ms-wmv",
              "description": "video/x-ms-wmv - WMV Video"
            },
            {
              "key": "video/x-ms-wmx",
              "description": "video/x-ms-wmx - WMX Video"
            },
            {
              "key": "video/x-ms-wvx",
              "description": "video/x-ms-wvx - WVX Video"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Character Set Id",
          "name": "characterSetId",
          "value": "",
          "id": "EditDataResource_characterSetId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "ISO-8859-1",
              "description": "ISO-8859-1"
            },
            {
              "key": "ISO-8859-10",
              "description": "ISO-8859-10"
            },
            {
              "key": "ISO-8859-2",
              "description": "ISO-8859-2"
            },
            {
              "key": "ISO-8859-3",
              "description": "ISO-8859-3"
            },
            {
              "key": "ISO-8859-4",
              "description": "ISO-8859-4"
            },
            {
              "key": "ISO-8859-5",
              "description": "ISO-8859-5"
            },
            {
              "key": "ISO-8859-6",
              "description": "ISO-8859-6"
            },
            {
              "key": "ISO-8859-7",
              "description": "ISO-8859-7"
            },
            {
              "key": "ISO-8859-8",
              "description": "ISO-8859-8"
            },
            {
              "key": "ISO-8859-9",
              "description": "ISO-8859-9"
            },
            {
              "key": "US-ASCII",
              "description": "US-ASCII"
            },
            {
              "key": "UTF-16",
              "description": "UTF-16"
            },
            {
              "key": "UTF-8",
              "description": "UTF-8"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Object Info",
          "name": "objectInfo",
          "value": "",
          "id": "EditDataResource_objectInfo",
          "required": false,
          "type": "text"
        },
        {
          "title": "Survey Id",
          "name": "surveyId",
          "value": "",
          "id": "EditDataResource_surveyId",
          "required": false,
          "type": "text"
        },
        {
          "title": "Survey Response Id",
          "name": "surveyResponseId",
          "value": "",
          "id": "EditDataResource_surveyResponseId",
          "required": false,
          "type": "text"
        },
        {
          "title": "Related Detail Id",
          "name": "relatedDetailId",
          "value": "",
          "id": "EditDataResource_relatedDetailId",
          "required": false,
          "type": "text"
        },
        {
          "title": "Is Public",
          "name": "isPublic",
          "value": "",
          "id": "EditDataResource_isPublic",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Created Date",
          "name": "createdDate",
          "value": "",
          "id": "EditDataResource_createdDate",
          "required": false,
          "type": "datetime"
        },
        {
          "title": "Created By User Login",
          "name": "createdByUserLogin",
          "value": "",
          "id": "EditDataResource_createdByUserLogin",
          "required": false,
          "type": "text"
        },
        {
          "title": "Last Modified Date",
          "name": "lastModifiedDate",
          "value": "",
          "id": "EditDataResource_lastModifiedDate",
          "required": false,
          "type": "datetime"
        },
        {
          "title": "Last Modified By User Login",
          "name": "lastModifiedByUserLogin",
          "value": "",
          "id": "EditDataResource_lastModifiedByUserLogin",
          "required": false,
          "type": "text"
        },
        {
          "title": "Update",
          "name": "updateButton",
          "value": "",
          "id": "EditDataResource_updateButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"ListDataResource",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Data Resource Id",
          "name": "dataResourceId",
          "value": "",
          "id": "ListDataResource_dataResourceId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Data Resource Name",
          "name": "dataResourceName",
          "value": "",
          "id": "ListDataResource_dataResourceName",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Data Resource Type Id",
          "name": "dataResourceTypeId",
          "value": "",
          "id": "ListDataResource_dataResourceTypeId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Mime Type Id",
          "name": "mimeTypeId",
          "value": "",
          "id": "ListDataResource_mimeTypeId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "ListDataResource_statusId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "ListDataResource_localeString",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Data Category Id",
          "name": "dataCategoryId",
          "value": "",
          "id": "ListDataResource_dataCategoryId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Data Resource Name",
          "name": "dataResourceName",
          "value": "",
          "id": "ListDataResource_dataResourceName",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Data Resource Type Id",
          "name": "dataResourceTypeId",
          "value": "",
          "id": "ListDataResource_dataResourceTypeId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Mime Type Id",
          "name": "mimeTypeId",
          "value": "",
          "id": "ListDataResource_mimeTypeId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "ListDataResource_statusId",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "ListDataResource_localeString",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Created By User Login",
          "name": "createdByUserLogin",
          "value": "",
          "id": "ListDataResource_createdByUserLogin",
          "event": "",
          "required": false,
          "type": "display"
        },
        {
          "title": "Data Category Id",
          "name": "dataCategoryId",
          "value": "",
          "id": "ListDataResource_dataCategoryId",
          "event": "",
          "required": false,
          "type": "display"
        }
      ]
    },
    //Website
    {
      "name":"FindWebSite",
      "target": "findWebSite",
      "targetWindow": "",
      "fields": [
        {
          "title": "No Condition Find",
          "name": "noConditionFind",
          "value": "",
          "id": "FindWebSite_noConditionFind",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Web Site Id",
          "name": "webSiteId",
          "value": "",
          "id": "FindWebSite_webSiteId",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Site Name",
          "name": "siteName",
          "value": "",
          "id": "FindWebSite_siteName",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Http Host",
          "name": "httpHost",
          "value": "",
          "id": "FindWebSite_httpHost",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Visual Theme Set Id",
          "name": "visualThemeSetId",
          "value": "",
          "id": "FindWebSite_visualThemeSetId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "BACKOFFICE",
              "description": "Themes to be used for backoffice applications"
            },
            {
              "key": "ECOMMERCE",
              "description": "Themes to be used for ECommerce applications"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Product Store Id",
          "name": "productStoreId",
          "value": "",
          "id": "FindWebSite_productStoreId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [],
          "textSize": 0
        },
        {
          "title": "Find",
          "name": "searchButton",
          "value": "",
          "id": "FindWebSite_searchButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name": "EditWebSite",
      "target": "updateWebSite",
      "targetWindow": "",
      "fields": [
        {
          "title": "Web Site Id",
          "name": "webSiteId",
          "value": "",
          "id": "EditWebSite_webSiteId",
          "event": "",
          "required": false
        },
        {
          "title": "Web Site Id",
          "name": "webSiteId",
          "value": "",
          "id": "EditWebSite_webSiteId",
          "event": "",
          "required": false
        },
        {
          "title": "Site Name",
          "name": "siteName",
          "value": "",
          "id": "EditWebSite_siteName",
          "required": false,
          "type": "text"
        },
        {
          "title": "Http Host",
          "name": "httpHost",
          "value": "",
          "id": "EditWebSite_httpHost",
          "required": false,
          "type": "text"
        },
        {
          "title": "Http Port",
          "name": "httpPort",
          "value": "",
          "id": "EditWebSite_httpPort",
          "required": false,
          "type": "text"
        },
        {
          "title": "Https Host",
          "name": "httpsHost",
          "value": "",
          "id": "EditWebSite_httpsHost",
          "required": false,
          "type": "text"
        },
        {
          "title": "Https Port",
          "name": "httpsPort",
          "value": "",
          "id": "EditWebSite_httpsPort",
          "required": false,
          "type": "text"
        },
        {
          "title": "Enable Https",
          "name": "enableHttps",
          "value": "",
          "id": "EditWebSite_enableHttps",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Standard Content Prefix",
          "name": "standardContentPrefix",
          "value": "",
          "id": "EditWebSite_standardContentPrefix",
          "required": false,
          "type": "text"
        },
        {
          "title": "Secure Content Prefix",
          "name": "secureContentPrefix",
          "value": "",
          "id": "EditWebSite_secureContentPrefix",
          "required": false,
          "type": "text"
        },
        {
          "title": "Cookie Domain",
          "name": "cookieDomain",
          "value": "",
          "id": "EditWebSite_cookieDomain",
          "required": false,
          "type": "text"
        },
        {
          "title": "Visual Theme Set Id",
          "name": "visualThemeSetId",
          "value": "",
          "id": "EditWebSite_visualThemeSetId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "BACKOFFICE",
              "description": "Themes to be used for backoffice applications"
            },
            {
              "key": "ECOMMERCE",
              "description": "Themes to be used for ECommerce applications"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Product Store Id",
          "name": "productStoreId",
          "value": "",
          "id": "EditWebSite_productStoreId",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [],
          "textSize": 0
        },
        {
          "title": "Allow Product Store Change",
          "name": "allowProductStoreChange",
          "value": "",
          "id": "EditWebSite_allowProductStoreChange",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Submit",
          "name": "submitButton",
          "value": "",
          "id": "EditWebSite_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"ListWebSites",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Web Site Id",
          "name": "webSiteId",
          "value": "",
          "id": "ListWebSites_webSiteId",
          "event": "",
          "required": false
        },
        {
          "title": "Site Name",
          "name": "siteName",
          "value": "",
          "id": "ListWebSites_siteName",
          "event": "list",
          "required": false,
          "type": "hyperlink",
          "target": "listWebSiteContents",
          "parameterList": [
            {
              "name": "webSiteId",
              "fromField": {
                "isEmpty": false,
                "original": "webSiteId",
                "bracketedOriginal": "${webSiteId}",
                "isAscending": true
              }
            }
          ],
          "formData":{
            "formLocation":"component://commonforms/widget/CommonFormsForms.xml",
            "formName":"ListWebSiteContent",
            "endPoint":"listFindWebSiteContent"
          }
        },
        {
          "title": "Http Host",
          "name": "httpHost",
          "value": "",
          "id": "ListWebSites_httpHost",
          "event": "",
          "required": false
        },
        {
          "title": "Visual Theme Set Id",
          "name": "visualThemeSetId",
          "value": "",
          "id": "ListWebSites_visualThemeSetId",
          "event": "",
          "required": false
        },
        {
          "title": "Product Store Id",
          "name": "productStoreId",
          "value": "",
          "id": "ListWebSites_productStoreId",
          "event": "",
          "required": false
        }
      ]
    },
    {
      "name":"ListWebSiteContent",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Web Site Id",
          "name": "webSiteId",
          "value": "",
          "id": "ListWebSiteContent_webSiteId",
          "event": "",
          "required": false,
          "type":"text"
        },
        {
          "title": "Content Id",
          "name": "contentId",
          "value": "",
          "id": "ListWebSiteContent_contentId",
          "event": "",
          "required": false,
          "type":"text"
        },
        {
          "title": "From Date",
          "name": "fromDate",
          "value": "",
          "id": "ListWebSiteContent_fromDate",
          "event": "",
          "required": false,
          "type":"date-time"
        },
        {
          "title": "Web Site Content Type Id",
          "name": "webSiteContentTypeId",
          "value": "",
          "id": "ListWebSiteContent_webSiteContentTypeId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "WebSiteContentType",
          "description": ""
        },
        {
          "title": "Thru Date",
          "name": "thruDate",
          "value": "",
          "id": "ListWebSiteContent_thruDate",
          "event": "",
          "required": false
        },
      ]
    },
    {
      "name":"FindWebSiteContent",
      "target": "findWebSiteContent",
      "targetWindow": "",
      "fields": [
        {
          "title": "No Condition Find",
          "name": "noConditionFind",
          "value": "",
          "id": "FindWebSiteContent_noConditionFind",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Web Site Id",
          "name": "webSiteId",
          "value": "",
          "id": "FindWebSiteContent_webSiteId",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Content Id",
          "name": "contentId",
          "value": "",
          "id": "FindWebSiteContent_contentId",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "From Date",
          "name": "fromDate",
          "value": "",
          "id": "FindWebSiteContent_fromDate",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Thru Date",
          "name": "thruDate",
          "value": "",
          "id": "FindWebSiteContent_thruDate",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Web Site Content Type Id",
          "name": "webSiteContentTypeId",
          "value": "",
          "id": "FindWebSiteContent_webSiteContentTypeId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "BLOG_ROOT",
              "description": "Blog Root"
            },
            {
              "key": "DEFAULT_PAGE",
              "description": "Default Page"
            },
            {
              "key": "ERROR_ROOT",
              "description": "Error Root"
            },
            {
              "key": "FORUM_ROOT",
              "description": "Forum Root"
            },
            {
              "key": "MENU_ROOT",
              "description": "Menu Root"
            },
            {
              "key": "PUBLISH_POINT",
              "description": "Publish Point"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Find",
          "name": "searchButton",
          "value": "",
          "id": "FindWebSiteContent_searchButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    //Survey
    {
      "name":"FindSurvey",
      "target": "FindSurvey",
      "targetWindow": "",
      "fields": [
        {
          "title": "No Condition Find",
          "name": "noConditionFind",
          "value": "",
          "id": "FindSurvey_noConditionFind",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Survey Id",
          "name": "surveyId",
          "value": "",
          "id": "FindSurvey_surveyId",
          "required": false,
          "type": "text"
        },
        {
          "title": "Survey Name",
          "name": "surveyName",
          "value": "",
          "id": "FindSurvey_surveyName",
          "required": false,
          "type": "text"
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "FindSurvey_description",
          "required": false,
          "type": "text"
        },
        {
          "title": "Comments",
          "name": "comments",
          "value": "",
          "id": "FindSurvey_comments",
          "required": false,
          "type": "text"
        },
        {
          "title": "Submit Caption",
          "name": "submitCaption",
          "value": "",
          "id": "FindSurvey_submitCaption",
          "required": false,
          "type": "text"
        },
        {
          "title": "Response Service",
          "name": "responseService",
          "value": "",
          "id": "FindSurvey_responseService",
          "required": false,
          "type": "text"
        },
        {
          "title": "Is Anonymous",
          "name": "isAnonymous",
          "value": "",
          "id": "FindSurvey_isAnonymous",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Allow Multiple",
          "name": "allowMultiple",
          "value": "",
          "id": "FindSurvey_allowMultiple",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Allow Update",
          "name": "allowUpdate",
          "value": "",
          "id": "FindSurvey_allowUpdate",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Acro Form Content Id",
          "name": "acroFormContentId",
          "value": "",
          "id": "FindSurvey_acroFormContentId",
          "required": false,
          "type": "lookup",
          "formName": "LookupContent"
        },
        {
          "title": "Find",
          "name": "submitButton",
          "value": "",
          "id": "FindSurvey_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"EditSurvey",
      "target": "updateSurvey",
      "targetWindow": "",
      "fields": [
        {
          "title": "Survey Id",
          "name": "surveyId",
          "value": "",
          "id": "EditSurvey_surveyId",
          "event": "",
          "required": false
        },
        {
          "title": "Survey Id",
          "name": "surveyId",
          "value": "",
          "id": "EditSurvey_surveyId",
          "event": "",
          "required": false
        },
        {
          "title": "Survey Name",
          "name": "surveyName",
          "value": "",
          "id": "EditSurvey_surveyName",
          "required": false,
          "type": "text"
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "EditSurvey_description",
          "required": false,
          "type": "text"
        },
        {
          "title": "Comments",
          "name": "comments",
          "value": "",
          "id": "EditSurvey_comments",
          "required": false,
          "type": "text"
        },
        {
          "title": "Submit Caption",
          "name": "submitCaption",
          "value": "",
          "id": "EditSurvey_submitCaption",
          "required": false,
          "type": "text"
        },
        {
          "title": "Response Service",
          "name": "responseService",
          "value": "",
          "id": "EditSurvey_responseService",
          "required": false,
          "type": "text"
        },
        {
          "title": "Is Anonymous",
          "name": "isAnonymous",
          "value": "",
          "id": "EditSurvey_isAnonymous",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Allow Multiple",
          "name": "allowMultiple",
          "value": "",
          "id": "EditSurvey_allowMultiple",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Allow Update",
          "name": "allowUpdate",
          "value": "",
          "id": "EditSurvey_allowUpdate",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "Y",
              "description": "Y"
            },
            {
              "key": "N",
              "description": "N"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Acro Form Content Id",
          "name": "acroFormContentId",
          "value": "",
          "id": "EditSurvey_acroFormContentId",
          "event": "",
          "required": false,
          "type": "lookup",
          "formName": "LookupContent"
        },
        {
          "title": "Update",
          "name": "submitButton",
          "value": "",
          "id": "EditSurvey_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"ListFindSurvey",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Survey Name",
          "name": "surveyName",
          "value": "",
          "id": "ListFindSurvey_surveyName",
          "required": false,
          "type":"display"
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "ListFindSurvey_description",
          "required": false,
          "type":"display"
        },
        {
          "title": "Comments",
          "name": "comments",
          "value": "",
          "id": "ListFindSurvey_comments",
          "required": false
        },
        {
          "title": "Submit Caption",
          "name": "submitCaption",
          "value": "",
          "id": "ListFindSurvey_submitCaption",
          "required": false
        },
        {
          "title": "Response Service",
          "name": "responseService",
          "value": "",
          "id": "ListFindSurvey_responseService",
          "required": false
        },
        {
          "title": "Is Anonymous",
          "name": "isAnonymous",
          "value": "",
          "id": "ListFindSurvey_isAnonymous",
          "required": false
        },
        {
          "title": "Allow Multiple",
          "name": "allowMultiple",
          "value": "",
          "id": "ListFindSurvey_allowMultiple",
          "required": false
        },
        {
          "title": "Allow Update",
          "name": "allowUpdate",
          "value": "",
          "id": "ListFindSurvey_allowUpdate",
          "required": false
        },
        {
          "title": "Acro Form Content Id",
          "name": "acroFormContentId",
          "value": "",
          "id": "ListFindSurvey_acroFormContentId",
          "required": false
        },
        {
          "title": "ContentSurveySurveyId",
          "name": "surveyId",
          "value": "",
          "id": "ListFindSurvey_surveyId",
          "required": false,
          "type": "hyperlink",
          "target": "EditSurvey",
          "parameterList": [
            {
              "name": "surveyId"
            }
          ]
        },
        {
          "title": "Survey Name",
          "name": "surveyName",
          "value": "",
          "id": "ListFindSurvey_surveyName",
          "required": false
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "ListFindSurvey_description",
          "required": false
        },
        {
          "title": "Comments",
          "name": "comments",
          "value": "",
          "id": "ListFindSurvey_comments",
          "required": false
        },
        {
          "title": "Submit Caption",
          "name": "submitCaption",
          "value": "",
          "id": "ListFindSurvey_submitCaption",
          "required": false
        },
        {
          "title": "Response Service",
          "name": "responseService",
          "value": "",
          "id": "ListFindSurvey_responseService",
          "required": false
        },
        {
          "title": "Is Anonymous",
          "name": "isAnonymous",
          "value": "",
          "id": "ListFindSurvey_isAnonymous",
          "required": false
        },
        {
          "title": "Allow Multiple",
          "name": "allowMultiple",
          "value": "",
          "id": "ListFindSurvey_allowMultiple",
          "required": false
        },
        {
          "title": "Allow Update",
          "name": "allowUpdate",
          "value": "",
          "id": "ListFindSurvey_allowUpdate",
          "required": false
        },
        {
          "title": "Acro Form Content Id",
          "name": "acroFormContentId",
          "value": "",
          "id": "ListFindSurvey_acroFormContentId",
          "required": false
        }
      ]
    },
    //Blog
    {
      "name" : "EditBlogRest",
      "altTarget" : [ {
        "useWhen" : "contentId==null",
        "targetExdr" : {
          "chars" : "newBlog",
          "hint" : 20,
          "empty" : false,
          "original" : "newBlog"
        }
      } ],
      "formLocation" : "component://content/widget/forum/BlogForms.xml",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "contentId",
        "action" : "",
        "id" : "EditBlog_contentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "contentTypeId",
        "action" : "",
        "id" : "EditBlog_contentTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "WEB_SITE_PUB_PT"
      }, {
        "conditionGroup" : "",
        "name" : "contentIdFrom",
        "action" : "",
        "id" : "EditBlog_contentIdFrom",
        "type" : "hidden",
        "event" : "",
        "value" : "BLOGROOT"
      }, {
        "conditionGroup" : "",
        "name" : "contentAssocTypeId",
        "action" : "",
        "id" : "EditBlog_contentAssocTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "SUB_CONTENT"
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "30",
        "ajaxUrl" : "",
        "maxlength" : "60",
        "tabindex" : "",
        "className" : "",
        "title" : "Blog Name",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "contentName",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditBlog_contentName",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "30",
        "ajaxUrl" : "",
        "maxlength" : "60",
        "tabindex" : "",
        "className" : "",
        "title" : "Blog Description",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "EditBlog_description",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, 
      {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "EditBlogRest",
        "tabindex" : "",
        "name" : "submitButton",
        "className" : "",
        "id" : "EditBlog_submitButton",
        "confirmation" : "",
        "type" : "SUBMIT",
        "title" : "CommonSubmit",
        "event" : "",
        "imgSrc" : ""
      } ],
      "target" : "updateBlog",
      "targets" : {
        createTarget:"newBlog",
        updateTarget:"updateBlog"
      }
    },
    {
      "name":"EditBlog",
      "target": "updateBlog",
      "targetWindow": "",
      "fields": [
        {
          "title": "Content Id",
          "name": "contentId",
          "value": "",
          "id": "EditBlog_contentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Assoc Type Id",
          "name": "contentAssocTypeId",
          "value": "SUB_CONTENT",
          "id": "EditBlog_contentAssocTypeId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "ContentBlogName",
          "name": "contentName",
          "value": "",
          "id": "EditBlog_contentName",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "ContentBlogDescription",
          "name": "description",
          "value": "",
          "id": "EditBlog_description",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Submit",
          "name": "submitButton",
          "value": "",
          "id": "EditBlog_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"ListBlogsRest",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Content Id",
          "name": "contentId",
          "value": "",
          "id": "ListBlogs_contentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Blog Name",
          "name": "contentName",
          "value": "",
          "id": "ListBlogs_contentName",
          "event": "list",
          "required": true,
          "type": "hyperlink",
          "target": "editBlog",
          "parameterList": [
            {
              "name": "blogContentId",
              "fromField": {
                "isEmpty": false,
                "original": "contentId",
                "bracketedOriginal": "${contentId}",
                "isAscending": true
              }
            }
          ],
          "formData":{
            "formName":"ListBlogContent",
            "formLocation":"component://content/widget/forum/BlogForms.xml",
            "viewIndex":1,
            "endPoint":"listFindBlogContent"
          }
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "ListBlogs_description",
          "event": "",
          "required": false
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "ListBlogs_statusId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "StatusItem",
          "description": ""
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "ListBlogs_localeString",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "CountryCode",
          "description": ""
        },
        {
          "title": "Content Type Id",
          "name": "contentTypeId",
          "value": "",
          "id": "ListBlogs_contentTypeId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "ContentType",
          "description": ""
        },
        {
          "title": "Last Modified Date",
          "name": "lastModifiedDate",
          "value": "",
          "id": "ListBlogs_lastModifiedDate",
          "event": "",
          "required": false
        },
        {
          "title": "Last Modified By User Login",
          "name": "lastModifiedByUserLogin",
          "value": "",
          "id": "ListBlogs_lastModifiedByUserLogin",
          "event": "",
          "required": false
        },
      ]
    },
    {
      "name":"FindBlogContent",
      "target": "findBlogContent",
      "targetWindow": "",
      "fields": [
        {
          "title": "No Condition Find",
          "name": "noConditionFind",
          "value": "",
          "id": "FindBlogContent_noConditionFind",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Assoc Type Id",
          "name": "caContentAssocTypeId",
          "value": "",
          "id": "FindBlogContent_caContentAssocTypeId",
          "event": "",
          "required": false
        },
        {
          "title": "Ca Thru Date",
          "name": "caThruDate",
          "value": "",
          "id": "FindBlogContent_caThruDate",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "ContentContentIdStart",
          "name": "contentIdStart",
          "value": "",
          "id": "FindBlogContent_contentIdStart",
          "event": "",
          "required": false,
          "type": "textqbe"
        },
        {
          "title": "Content Assoc Type Id",
          "name": "caContentAssocTypeId",
          "value": "",
          "id": "FindBlogContent_caContentAssocTypeId",
          "event": "",
          "required": false
        },
        {
          "title": "Find",
          "name": "searchButton",
          "value": "",
          "id": "FindBlogContent_searchButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"ListBlogContent",
      "target": "",
      "targetWindow": "",
      "fields": [
        {
          "title": "Content Id",
          "name": "contentId",
          "value": "",
          "id": "ListBlogContent_contentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Name",
          "name": "contentName",
          "value": "",
          "id": "ListBlogContent_contentName",
          "event": "edit",
          "required": false,
          "type": "hyperlink",
          "target": "ViewBlogArticle",
          
          "parameterList": [
            {
              "name": "articleContentId",
              "fromField": {
                "isEmpty": false,
                "original": "contentId",
                "bracketedOriginal": "${contentId}",
                "isAscending": true
              }
            },
            {
              "name": "blogContentId",
              "fromField": {
                "isEmpty": false,
                "original": "contentIdStart",
                "bracketedOriginal": "${blogContentId}",
                "isAscending": true
              }
            }
          ],
          "formData":{
            "formLocation":"component://content/widget/forum/BlogForms.xml",
            "formName":"EditArticleRest",
            "endPoint":"view"
          }
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "ListBlogContent_description",
          "event": "",
          "required": false
        },
        {
          "title": "Status ID",
          "name": "statusId",
          "value": "",
          "id": "ListBlogs_statusId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "StatusItem",
          "description": ""
        },
        {
          "title": "Locale String",
          "name": "localeString",
          "value": "",
          "id": "ListBlogs_localeString",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "CountryCode",
          "description": ""
        },
        {
          "title": "Content Type Id",
          "name": "contentTypeId",
          "value": "",
          "id": "ListBlogs_contentTypeId",
          "event": "",
          "required": false,
          "type": "display-entity",
          "entityName": "ContentType",
          "description": ""
        },

      ]
    },
    {
      "name":"EditArticleRest",
      "target": "createBlogArticle",
      "altTargets":[
        {
          useWhen:"contentId!=void&&contentId!=null",
          targetExdr:{
            original:"updateBlogArticle"
          }
        }
      ],
      "targetWindow": "",
      "fields": [
        {
          "title": "Blog Content Id",
          "name": "blogContentId",
          "value": "",
          "id": "EditArticle_blogContentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "ContentArticleName",
          "name": "contentName",
          "value": "",
          "id": "EditArticle_contentName",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "EditArticle_description",
          "event": "",
          "required": false,
          "type": "textarea"
        },
        {
          "title": "ContentSummary",
          "name": "summaryData",
          "value": "",
          "id": "EditArticle_summaryData",
          "event": "",
          "required": false,
          "type": "textarea"
        },
        {
          "title": "ContentBlogArticle",
          "name": "articleData",
          "value": "",
          "id": "EditArticle_articleData",
          "event": "",
          "required": false,
          "type": "textarea"
        },
        {
          "title": "ContentImage",
          "name": "uploadedFile",
          "value": "",
          "id": "EditArticle_uploadedFile",
          "event": "",
          "required": false,
          "type":"file"
        },
        {
          "title": "ContentTemplate",
          "name": "templateDataResourceId",
          "value": "",
          "id": "EditArticle_templateDataResourceId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "BLOG_TPL_TOPLEFT",
              "description": "ContentBlogTopLeft"
            },
            {
              "key": "BLOG_TPL_TOPCENTER",
              "description": "ContentBlogTopCenter"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Status",
          "name": "statusId",
          "value": "",
          "id": "EditArticle_statusId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "CTNT_PUBLISHED",
              "description": "ContentBlogPublish"
            },
            {
              "key": "CTNT_INITIAL_DRAFT",
              "description": "ContentBlogPreview"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Submit",
          "name": "submitButton",
          "value": "",
          "id": "EditArticle_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"EditArticle",
      "target": "createBlogArticle",
      "targetWindow": "",
      "fields": [
        {
          "title": "Blog Content Id",
          "name": "blogContentId",
          "value": "",
          "id": "EditArticle_blogContentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Article Name",
          "name": "contentName",
          "value": "",
          "id": "EditArticle_contentName",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Description",
          "name": "description",
          "value": "",
          "id": "EditArticle_description",
          "event": "",
          "required": false,
          "type": "textarea"
        },
        {
          "title": "Summary",
          "name": "summaryData",
          "value": "",
          "id": "EditArticle_summaryData",
          "event": "",
          "required": false,
          "type": "textarea"
        },
        {
          "title": "Article",
          "name": "articleData",
          "value": "",
          "id": "EditArticle_articleData",
          "event": "",
          "required": false,
          "type": "textarea"
        },
        {
          "title": "Image",
          "name": "uploadedFile",
          "value": "",
          "id": "EditArticle_uploadedFile",
          "event": "",
          "required": false
        },
        {
          "title": "Template",
          "name": "templateDataResourceId",
          "value": "",
          "id": "EditArticle_templateDataResourceId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "BLOG_TPL_TOPLEFT",
              "description": "Top Left"
            },
            {
              "key": "BLOG_TPL_TOPCENTER",
              "description": "Top Center"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Status",
          "name": "statusId",
          "value": "",
          "id": "EditArticle_statusId",
          "event": "",
          "required": false,
          "type": "dropdown",
          "allOptionValues": [
            {
              "key": "CTNT_PUBLISHED",
              "description": "Publish"
            },
            {
              "key": "CTNT_INITIAL_DRAFT",
              "description": "Preview"
            }
          ],
          "textSize": 0
        },
        {
          "title": "Submit",
          "name": "submitButton",
          "value": "",
          "id": "EditArticle_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    //Forum
    {
      "name" : "AddForumRest",
      "altTarget" : [ ],
      "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
      "targets":{
        createTarget:"createForum",
      },
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "forumGroupId",
        "action" : "",
        "id" : "AddForum_forumGroupId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "contentTypeId",
        "action" : "",
        "id" : "AddForum_contentTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "WEB_SITE_PUB_PT"
      }, {
        "conditionGroup" : "",
        "name" : "ownerContentId",
        "action" : "",
        "id" : "AddForum_ownerContentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "caContentId",
        "action" : "",
        "id" : "AddForum_caContentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "caContentAssocTypeId",
        "action" : "",
        "id" : "AddForum_caContentAssocTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "SUBSITE"
      }, {
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Forum Name",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "contentName",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "AddForum_forumName",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Forum Description",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "AddForum_forumDescription",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "classString" : "",
        "shortDateInput" : "false",
        "ampmName" : "",
        "className" : "",
        "title" : "CommonFormatDateTime",
        "type" : "datetime",
        "dateType" : "timestamp",
        "defaultDateTimeString" : "",
        "timeDropdown" : "text",
        "alert" : "false",
        "timeValues" : "",
        "formName" : "AddForumRest",
        "timeDropdownParamName" : "caFromDate",
        "timeMinutesName" : "",
        "disabled" : "false",
        "id" : "AddForum_caFromDate",
        "event" : "",
        "value" : "",
        "pmSelected" : "",
        "mask" : "",
        "hour1" : "0",
        "isTwelveHour" : "false",
        "fieldHelpText" : "",
        "hour2" : "0",
        "maxlength" : "30",
        "minutes" : "0",
        "tabindex" : "",
        "amSelected" : "",
        "size" : "25",
        "isXMLHttpRequest" : "false",
        "localizedIconTitle" : "CommonViewCalendar",
        "timeHourName" : "",
        "name" : "caFromDate",
        "style" : "",
        "step" : "1",
        "compositeType" : ""
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "AddForumRest",
        "tabindex" : "",
        "name" : "addButton",
        "className" : "smallSubmit",
        "id" : "AddForum_addButton",
        "confirmation" : "",
        "type" : "submit",
        "title" : "CommonAdd",
        "event" : "",
        "imgSrc" : ""
      } ],
    },


    {
      "name":"AddForum",
      "target": "createForum",
      "targetWindow": "",
      "fields": [
        {
          "title": "Forum Group Id",
          "name": "forumGroupId",
          "value": "",
          "id": "AddForum_forumGroupId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Type Id",
          "name": "contentTypeId",
          "value": "",
          "id": "AddForum_contentTypeId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Owner Content Id",
          "name": "ownerContentId",
          "value": "",
          "id": "AddForum_ownerContentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Ca Content Id",
          "name": "caContentId",
          "value": "",
          "id": "AddForum_caContentId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Assoc Type Id",
          "name": "caContentAssocTypeId",
          "value": "",
          "id": "AddForum_caContentAssocTypeId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Forum Name",
          "name": "contentName",
          "value": "",
          "id": "AddForum_forumName",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Forum Description",
          "name": "description",
          "value": "",
          "id": "AddForum_forumDescription",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Ca From Date",
          "name": "caFromDate",
          "value": "",
          "id": "AddForum_caFromDate",
          "event": "",
          "required": false,
          "type": "datetime"
        },
        {
          "title": "Add",
          "name": "addButton",
          "value": "",
          "id": "AddForum_addButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name":"ListForumsRest",
      "target": "updateForum",
      "targets":{
        updateTarget:"updateForum"
      },
      "targetWindow": "",
      "fields": [
        {
          "title": "Forum Group Id",
          "name": "forumGroupId",
          "value": "",
          "id": "ListForums_forumGroupId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Id To",
          "name": "contentIdTo",
          "value": "",
          "id": "ListForums_contentIdTo",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Assoc Type Id",
          "name": "contentAssocTypeId",
          "value": "",
          "id": "ListForums_contentAssocTypeId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Content Type Id",
          "name": "contentTypeId",
          "value": "",
          "id": "ListForums_contentTypeId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Select",
          "name": "contentId",
          "value": "",
          "id": "ListForums_select",
          "event": "list",
          "required": false,
          "widgetStyle": "buttontext",
          "type": "hyperlink",
          "target": "findForumMessages",
          "parameterList": [
            {
              "name": "forumGroupId",
              "fromField": {
                "isEmpty": false,
                "original": "forumGroupId",
                "bracketedOriginal": "${forumGroupId}",
                "isAscending": true
              }
            },
            {
              "name": "forumId",
              "fromField": {
                "isEmpty": false,
                "original": "contentId",
                "bracketedOriginal": "${contentId}",
                "isAscending": true
              }
            }
          ],
          "formData":{
            "formName":"ListForumMessagesRest",
            "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
            "viewIndex":1,
            "endPoint":"listFindBlogContent"
          },
          "description": "Messages"
        },
        {
          "title": "Delete",
          "name": "deleteButton",
          "value": "",
          "id": "ListForums_deleteButton",
          "event": "",
          "required": false,
          "widgetStyle": "buttontext",
          "type": "hyperlink",
          "target": "updateForum",
          "parameterList": [
            {
              "name": "forumGroupId",
              "fromField": {
                "isEmpty": false,
                "original": "forumGroupId",
                "bracketedOriginal": "${forumGroupId}",
                "isAscending": true
              }
            },
            {
              "name": "contentIdTo",
              "fromField": {
                "isEmpty": false,
                "original": "forumGroupId",
                "bracketedOriginal": "${forumGroupId}",
                "isAscending": true
              }
            },
            {
              "name": "contentId"
            },
            {
              "name": "contentAssocTypeId",
              "fromField": {
                "isEmpty": false,
                "original": "caContentAssocTypeId",
                "bracketedOriginal": "${caContentAssocTypeId}",
                "isAscending": true
              }
            },
            {
              "name": "fromDate",
              "fromField": {
                "isEmpty": false,
                "original": "caFromDate",
                "bracketedOriginal": "${caFromDate}",
                "isAscending": true
              }
            },
            {
              "name": "deactivateExisting",
              "value": {
                "chars": [
                  "y",
                  "e",
                  "s"
                ],
                "hint": 20
              }
            }
          ],
          "description": "Delete"
        },
        {
          "title": "From Date",
          "name": "fromDate",
          "entryName": "caFromDate",
          "value": "",
          "id": "ListForums_fromDate",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Nbr Of Messages",
          "name": "nbrOfMessages",
          "entryName": "childBranchCount",
          "value": "",
          "id": "ListForums_nbrOfMessages",
          "event": "",
          "required": false
        },
        {
          "title": "Forum Name",
          "name": "contentName",
          "value": "",
          "id": "ListForums_forumName",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Forum Description",
          "name": "description",
          "value": "",
          "id": "ListForums_forumDescription",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Thru Date",
          "name": "thruDate",
          "entryName": "caThruDate",
          "value": "",
          "id": "ListForums_thruDate",
          "event": "",
          "required": false,
          "type": "datetime"
        },
        {
          "title": "Update",
          "name": "updateButton",
          "value": "",
          "id": "ListForums_updateButton",
          "event": "",
          "required": false,
          "type": "submit"
        },
      ]
    },
    {
      "name":"AddForumGroup",
      "target": "createForumGroup",
      "targets":{
        createTarget:"createForumGroup",
        updateTarget:"updateForumGroup"
      },
      "targetWindow": "",
      "fields": [
        {
          "title": "Content Id",
          "name": "contentId",
          "type": "hidden"
        },
        {
          "title": "Content Type Id",
          "name": "contentTypeId",
          "value": "FORUM_ROOT",
          "id": "AddForumGroup_contentTypeId",
          "event": "",
          "required": false,
          "type": "hidden"
        },
        {
          "title": "Forum Group Name",
          "name": "contentName",
          "value": "",
          "id": "AddForumGroup_forumGroupName",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Forum Group Description",
          "name": "description",
          "value": "",
          "id": "AddForumGroup_forumGroupDescription",
          "event": "",
          "required": false,
          "type": "text"
        },
        {
          "title": "Submit",
          "name": "submitButton",
          "value": "",
          "id": "AddForumGroup_submitButton",
          "event": "",
          "required": false,
          "type": "submit"
        }
      ]
    },
    {
      "name" : "ListForumGroupsRest",
      "altTarget" : [ ],
      "targets" : {
        updateTarget:"updateForumGroup"
      },
      "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "contentId",
        "action" : "",
        "id" : "ListForumGroupsRest_contentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      },{
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "Forums",
        "title" : "Select",
        "type" : "hyperlink",
        "name" : "select",
        "width" : "",
        "event": "list",
        "parameterList" : [ {
          "fromField" : {
            "isEmpty" : false,
            "original" : "contentId",
            "bracketedOriginal" : "${contentId}",
            "isAscending" : true,
            "empty" : false,
            "originalName" : "contentId"
          },
          "name" : "forumGroupId"
        } ],
        "formData":{
          "formName":"ListForumsRest",
          "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
          "viewIndex":1,
          "endPoint":"listFindBlogContent"
        },
        "style" : "",
        "id" : "ListForumGroups_select",
        "imageTitle" : "",
        "parameterMap" : { },
        "height" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Forum Group Name",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "contentName",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "ListForumGroups_forumGroupName",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Forum Group Description",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "ListForumGroups_forumGroupDescription",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "buttonType" : "text-link",
        "alert" : "false",
        "formName" : "ListForumGroupsRest",
        "tabindex" : "",
        "name" : "updateButton",
        "className" : "buttontext",
        "id" : "ListForumGroups_updateButton",
        "confirmation" : "",
        "type" : "submit",
        "title" : "CommonUpdate",
        "event" : "",
        "imgSrc" : ""
      } ],
      
     },
    {
      "name" : "ListForumMessagesRest",
      "altTarget" : [ ],
      "target" : "updateForumMessage",
      "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
      "fields" : [ 
        {
        "conditionGroup" : "",
        "name" : "forumGroupId",
        "action" : "",
        "id" : "ListForumMessages_forumGroupId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "conditionGroup" : "",
        "name" : "forumId",
        "action" : "",
        "id" : "ListForumMessages_forumId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "conditionGroup" : "",
        "name" : "contentId",
        "action" : "",
        "id" : "ListForumMessages_contentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "conditionGroup" : "",
        "name" : "contentIdTo",
        "action" : "",
        "id" : "ListForumMessages_contentIdTo",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "conditionGroup" : "",
        "name" : "contentAssocTypeId",
        "action" : "",
        "id" : "ListForumMessages_contentAssocTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "conditionGroup" : "",
        "name" : "contentTypeId",
        "action" : "",
        "id" : "ListForumMessages_contentTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "conditionGroup" : "",
        "name" : "dataResourceTypeId",
        "action" : "",
        "id" : "ListForumMessages_dataResourceTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "ELECTRONIC_TEXT"
      }, 
      {
        "conditionGroup" : "",
        "name" : "dataResourceId",
        "action" : "",
        "id" : "ListForumMessages_dataResourceId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, 
      {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "messageTitle",
        "description" : "",
        "style" : "",
        "id" : "ListForumMessages_messageTitle",
        "title" : "",
        "type" : "display",
        "imageLocation" : ""
      }, 
      {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "createdBy",
        "description" : "",
        "style" : "",
        "id" : "ListForumMessages_createdBy",
        "title" : "Created By",
        "type" : "display",
        "imageLocation" : ""
      }, 
      {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "fromDate",
        "description" : "",
        "style" : "",
        "id" : "ListForumMessages_fromDate",
        "title" : "From Date",
        "type" : "display",
        "imageLocation" : ""
      }, 
      {
        "fieldHelpText" : "",
        "ajaxEnabled" : false,
        "size" : 0,
        "name" : "thruDate",
        "description" : "",
        "style" : "",
        "id" : "ListForumMessages_thruDate",
        "title" : "Thru Date",
        "type" : "display",
        "imageLocation" : ""
      }, 
      {
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "CommonDelete",
        "title" : "Delete",
        "type" : "hyperlink",
        "event":"delete",
        "target": "updateForumMessage",
        "name" : "deleteButton",
        "width" : "",
        "formData":{
          endPoint:"updateForumMessage",
        },
        "parameterList" : [ {
          "fromField" : {
            "isEmpty" : false,
            "original" : "forumGroupId",
            "bracketedOriginal" : "${forumGroupId}",
            "isAscending" : true,
            "empty" : false,
            "originalName" : "forumGroupId"
          },
          "name" : "forumGroupId"
        }, {
          "fromField" : {
            "isEmpty" : false,
            "original" : "${forumId}",
            "fse" : {
              "chars" : "${forumId}",
              "hint" : 20,
              "offset" : 0,
              "length" : 21,
              "bracketedOriginal" : "${forumId}",
              "empty" : false,
              "original" : "${forumId}"
            },
            "isAscending" : true,
            "empty" : false,
            "originalName" : "${forumId}"
          },
          "name" : "forumId"
        }, {
          "name" : "caContentIdTo"
        }, {
          "name" : "caContentId"
        }, {
          "name" : "caContentAssocTypeId"
        }, {
          "name" : "caFromDate"
        }, {
          "name" : "deactivateExisting",
          "value" : {
            "chars" : "true",
            "hint" : 20,
            "empty" : false,
            "original" : "true"
          }
        } ],
        "style" : "",
        "id" : "ListForumMessages_deleteButton",
        "imageTitle" : "",
        "parameterMap" : {
          "deactivateExisting" : "true"
        },
        "height" : ""
      }, 
      {
        "fieldHelpText" : "",
        "buttons" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "language" : "en",
        "title" : "Message Text ",
        "type" : "textArea",
        "rows" : "8",
        "readonly" : "",
        "visualEditorEnable" : "",
        "alert" : "false",
        "name" : "textData",
        "style" : "",
        "disabled" : "false",
        "id" : "ListForumMessages_messageText",
        "value" : "",
        "cols" : "60"
      }, 
      {
        "buttonType" : "text-link",
        "alert" : "false",
        "formName" : "ListForumMessagesRest",
        "tabindex" : "",
        "name" : "updateButton",
        "className" : "buttontext",
        "id" : "ListForumMessages_updateButton",
        "confirmation" : "",
        "type" : "submit",
        "title" : "CommonUpdate",
        "event" : "",
        "imgSrc" : ""
      }, 
      {
        "image" : "",
        "fieldHelpText" : "",
        "alternate" : "",
        "description" : "Resp.",
        "title" : "Resp.",
        "type" : "hyperlink",
        "event":"add",
        "name" : "responseButton",
        "width" : "",
        "parameterList" : [ {
          "fromField" : {
            "isEmpty" : false,
            "original" : "forumGroupId",
            "bracketedOriginal" : "${forumGroupId}",
            "isAscending" : true,
            "empty" : false,
            "originalName" : "forumGroupId"
          },
          "name" : "forumGroupId"
        }, {
          "fromField" : {
            "isEmpty" : false,
            "original" : "forumId",
            "bracketedOriginal" : "${forumId}",
            "isAscending" : true,
            "empty" : false,
            "originalName" : "forumId"
          },
          "name" : "forumId"
        }, {
          "fromField" : {
            "isEmpty" : false,
            "original" : "contentId",
            "bracketedOriginal" : "${contentId}",
            "isAscending" : true,
            "empty" : false,
            "originalName" : "contentId"
          },
          "name" : "forumMessageIdTo"
        }, {
          "name" : "contentAssocTypeId",
          "value" : {
            "chars" : "RESPONSE",
            "hint" : 20,
            "empty" : false,
            "original" : "RESPONSE"
          }
        } ],
        "style" : "",
        "id" : "ListForumMessages_responseButton",
        "imageTitle" : "",
        "parameterMap" : {
          "contentAssocTypeId" : "RESPONSE"
        },
        "height" : "",
        "formData":{
          "formName":"AddForumMessageRest",
          "formLocation":"component://kwikstore/widget/KwikstoreForms.xml",
        },
      } ],
      
    },
    {
      "name" : "AddForumMessageRest",
      "targets" : {
        createTarget:"updateForumMessage",
        updateTarget:"updateForumMessage"
      },
      "formLocation" : "component://kwikstore/widget/KwikstoreForms.xml",
      "fields" : [ {
        "conditionGroup" : "",
        "name" : "VIEW_INDEX",
        "action" : "",
        "id" : "AddForumMessage_VIEW_INDEX",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "threadView",
        "action" : "",
        "id" : "AddForumMessage_threadView",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "forumGroupId",
        "action" : "",
        "id" : "AddForumMessage_forumGroupId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "dataResourceTypeId",
        "action" : "",
        "id" : "AddForumMessage_dataResourceTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "ELECTRONIC_TEXT"
      }, {
        "conditionGroup" : "",
        "name" : "forumId",
        "action" : "",
        "id" : "AddForumMessage_forumId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "contentName",
        "action" : "",
        "id" : "AddForumMessage_contentName",
        "type" : "hidden",
        "event" : "",
        "value" : "New thread/message/response"
      }, {
        "conditionGroup" : "",
        "name" : "contentTypeId",
        "action" : "",
        "id" : "AddForumMessage_contentTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "DOCUMENT"
      }, {
        "conditionGroup" : "",
        "name" : "ownerContentId",
        "action" : "",
        "id" : "AddForumMessage_ownerContentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "caContentId",
        "action" : "",
        "id" : "AddForumMessage_caContentId",
        "type" : "hidden",
        "event" : "",
        "value" : ""
      }, {
        "conditionGroup" : "",
        "name" : "caContentAssocTypeId",
        "action" : "",
        "id" : "AddForumMessage_caContentAssocTypeId",
        "type" : "hidden",
        "event" : "",
        "value" : "RESPONSE"
      }, {
        "" : "",
        "fieldHelpText" : "",
        "textSize" : "25",
        "ajaxUrl" : "",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "title" : "Message Title",
        "type" : "text",
        "clientAutocomplete" : "true",
        "ajaxEnabled" : true,
        "readonly" : false,
        "alert" : "false",
        "name" : "description",
        "action" : "",
        "style" : "",
        "disabled" : false,
        "id" : "AddForumMessage_forumMessageTitle",
        "placeholder" : "",
        "event" : "",
        "value" : "",
        "mask" : ""
      }, {
        "fieldHelpText" : "",
        "buttons" : "compact",
        "maxlength" : "",
        "tabindex" : "",
        "className" : "",
        "language" : "en",
        "title" : "Message Body text",
        "type" : "textarea",
        "rows" : "10",
        "readonly" : "",
        "visualEditorEnable" : "true",
        "alert" : "false",
        "name" : "textData",
        "style" : "",
        "disabled" : "false",
        "id" : "AddForumMessage_forumMessageText",
        "value" : "",
        "cols" : "60"
      }, {
        "buttonType" : "button",
        "alert" : "false",
        "formName" : "AddForumMessageRest",
        "tabindex" : "",
        "name" : "addButton",
        "className" : "smallSubmit",
        "id" : "AddForumMessage_addButton",
        "confirmation" : "",
        "type" : "submit",
        "title" : "CommonAdd",
        "event" : "",
        "imgSrc" : ""
      } ],
      
    },
]